import React from 'react';
import {useLocation} from 'react-router-dom';
import styled from 'styled-components';
import {mobileMediaQuery} from '../styles';

const DKidsPolicy = () => {
    //get current route
    const location = useLocation();

    if (location.pathname.indexOf('politica-de-privacidade') > -1) {
        return (
            <Container>
                <div class="cuerpo">
                    <h1>POLÍTICA DE PRIVACIDADE</h1>
                    <p>
                        A Discovery Communications, LLC. (“Discovery”) respeita
                        a sua privacidade, e queremos que você entenda como
                        utilizamos os dados que você transmite ao visitar o
                        website e aplicativo do Discovery K!ds Plus (“Site”).
                        Essa política se aplica única e exclusivamente para
                        dados coletados no Site. AO UTILIZAR ESTE SITE, VOCÊ
                        CONCORDA COM OS TERMOS E CONDIÇÕES DESTA POLÍTICA DE
                        PRIVACIDADE. SE VOCÊ NÃO CONCORDA COM OS TERMOS E
                        CONDIÇÕES DESTA POLÍTICA DE PRIVACIDADE, POR FAVOR, NÃO
                        UTILIZE ESTE SITE.
                    </p>

                    <p>
                        A Internet é uma mídia em evolução. Se houver
                        necessidade de mudarmos nossa Política de Privacidade,
                        publicaremos as mudanças aqui. Você pode verificar
                        quando esta Política de Privacidade foi atualizada pela
                        última vez, consultando a data da “Última Atualização”
                        que aparece na parte inferior desta página. Quaisquer
                        mudanças em nossa Política de Privacidade se tornarão
                        efetivas com a publicação da nova Política de
                        Privacidade revisada. O uso do Site, após estas
                        mudanças, representa sua concordância com a Política de
                        Privacidade atualizada. Para os casos específicos em que
                        houver (se houver) tratamento de dados pessoais baseado
                        no consentimento (art.7º, I, Lei 13.709/2018), caso haja
                        alteração da Política de Privacidade, o titular dos
                        dados será notificado para decidir se manterá o
                        consentimento ou não.{' '}
                    </p>

                    <p>
                        Este Site é controlado e operado por nós a partir dos
                        Estados Unidos, e está sujeito à jurisdição dos Estados
                        Unidos. Entretanto, para os usuários que acessam o Site
                        no território brasileiro, será observada a jurisdição
                        brasileira.
                    </p>

                    <h2>A. TIPO DE INFORMAÇÃO COLETADA</h2>

                    <p>
                        Nós coletamos 2 (dois) tipos de informações dos
                        visitantes do Site: (a) Dados Pessoais e (b) Dados Não
                        Pessoais. Não coletamos dados de crianças, salvo com
                        consentimento específico de pelo menos um dos pais ou do
                        responsável legal.
                    </p>
                    <ol>
                        <li>
                            <b>“Dados Pessoais”</b> são dados que te identificam
                            pessoalmente, tais como nome, endereço, número de
                            telefone, endereço de e-mail, empresa em que
                            trabalha. Tais informações são obtidas a partir da
                            inserção delas no Site, por você, e são utilizadas,
                            por exemplo, para te enviar informações, como
                            “newsletters”, publicidade da Discovery e/ou de
                            terceiros, para sua participação em promoções, para
                            autenticação de nossa oferta de vídeo, entre outros.
                            Se você não quer que a Discovery colete tais
                            informações, por favor, não as forneça para a
                            Discovery;
                        </li>

                        <li>
                            <b>“Dados Não Pessoais”</b> são dados técnicos ou
                            demográficos que não te identificam pessoalmente ou
                            que não estão vinculados a você.{' '}
                        </li>
                    </ol>

                    <h2>
                        B. INFORMAÇÕES GERAIS DE PRIVACIDADE SOBRE DADOS DE
                        CRIANÇAS
                    </h2>

                    <h3>1.1 Um Aviso às Crianças</h3>
                    <p>
                        Crianças (de até 12 anos de idade) deverão obter a
                        permissão de seus pais ou responsáveis legais antes de
                        utilizar o Site ou enviar qualquer dado pessoal (como
                        nome ou endereço) pela Internet, através de nosso Site.
                    </p>

                    <h3>
                        1.2 Um Aviso aos Pais/Responsáveis - LEIA, POR FAVOR
                    </h3>
                    <p>
                        Esta seção da Política de Privacidade explica como é
                        feita a coleta de dados, bem como as práticas usuais
                        para a utilização do Site por crianças, incluindo o que
                        fazemos com os dados coletados e com quem compartilhamos
                        esses dados. Nós pedimos que esta seção seja lida com
                        atenção, para que você saiba exatamente como os dados
                        são coletados e utilizados, e também como você deve
                        proceder caso queira adotar alguma medida com relação a
                        tais informações.
                    </p>

                    <h3>
                        1.3 Quais dados coletamos de crianças (caso seja
                        autorizado expressamente por pelo menos um dos pais ou
                        pelo responsável legal) e como tais dados são utilizados
                    </h3>

                    <p>
                        1.3.1 A Discovery limita os dados coletados de criança a
                        nome fictício (apelido) ou primeiro nome, idade (podendo
                        incluir dia e mês de nascimento) e gênero, de acordo com
                        o que for inserido pelo usuário. Essa informação é
                        requisitada para criação de perfil (o que é facultativo)
                        pelos pais ou responsáveis legais, bem como para
                        eventuais ações de marketing da Discovery (por exemplo,
                        comemoração de aniversário da criança).
                    </p>

                    <p>
                        1.3.2 Sempre que houver tratamento de dados de criança,
                        a Discovery solicitará dados pessoais de seus
                        pais/responsáveis, com o intuito de identificar o
                        responsável pelo consentimeno legal e viabilizar a
                        resposta a determinado pedido/solicitação feito em nosso
                        Site.
                    </p>

                    <p>
                        1.3.3 A Discovery enviará uma mensagem ao endereço de
                        e-mail fornecido pelos pais/responsáveis, no caso de
                        cadastro para eventos, contendo informações detalhadas
                        de como você fornecerá a autorização para que seu filho
                        participe ou, se for o caso, como proibir que a
                        Discovery volte a entrar em contato. Além disso, ao
                        final da página do Sites, é possível solicitar que a
                        Discovery descadastre um e-mail que tenha sido fornecido
                        por você para o envio de mensagens. A Discovery não
                        coletará dados além dos necessários para que a criança
                        possa participar das atividades desejadas.
                    </p>

                    <p>
                        1.3.4 Algumas partes do Site exigem que Dados Pessoais
                        sejam submetidos para permitir o acesso / a
                        participação. Por exemplo, se você desejar criar um
                        perfil para seu filho, se pretender acessar áreas
                        restritas a assinantes, se você quiser receber uma de
                        nossas malas diretas (newsletters) ou se você tiver
                        interesse em cadastrar seu filho para participar de
                        eventos, você precisará nos informar o seu e-mail, além
                        de informações pertinentes a cada uma destas atividades
                        descritas e no limite necessário para sual realização. O
                        Site dispõe de um sistema de confirmação de acesso por
                        senha que é encaminhadea ao e-mail do pai/mãe ou
                        responsável legal, para evitar que crianças se
                        cadastrem. Nós não permitimos que qualquer criança faça
                        seu cadastro em nosso Site, ou acesse parte do Site que
                        exija cadastro, o qual, caso exista, deverá ser
                        realizado pelos pais ou resposável legal da criança.
                    </p>

                    <p>
                        1.3.5 Caso a Discovery tenha ciência de que Dados
                        Pessoais de uma criança foram coletados sem o devido
                        consentimento dos pais ou responsável legal, a não ser
                        que seja em uma situação admitida por lei, os dados
                        serão apagados de nossos registros imediatamente após
                        tomarmos ciência do fato.
                    </p>

                    <p>
                        1.3.6 Como pai/mãe ou responsável legal, você pode
                        exercer o direito de ter os dados de seus filhos / da
                        criança pelo qual é responsável legal apagados a
                        qualquer momento. Para tanto, basta acessar o link do
                        formulário e realizar referido pedido.
                    </p>

                    <h3>
                        1.4 Como os Dados Pessoais de crianças são utilizados
                    </h3>

                    <p>
                        1.4.1 Quando coletamos Dados Pessoais de crianças, esses
                        dados são utilizados apenas para a atividade que os
                        exigiu. Os Dados Pessoais não serão usados para outra
                        finalidade.
                    </p>

                    <h3>
                        1.5 Como os Dados Pessoais de crianças são
                        compartilhados
                    </h3>

                    <p>
                        1.5.1 Nós não compartilhamos os Dados Pessoais de
                        crianças com terceiros, com exceção daqueles que nos
                        ajudam a administrar nosso Site e que nos fornecem
                        outros tipos de serviços administrativos. Nós
                        trabalhamos para assegurar que terceiros não usem esses
                        Dados Pessoais para outros fins. Esses terceiros
                        concordam em manter os dados pessoais confidenciais,
                        seguros e íntegros. Os Dados Pessoais não serão
                        utilizados por esses terceiros após a conclusão da
                        atividade desempenhada pelos mesmos com relação a tais
                        dados.
                    </p>

                    <p>
                        1.5.2 Se o seu filho for selecionado como um potencial
                        vencedor de alguma de nossas promoções ou concursos, nós
                        notificaremos você através do e-mail que foi informado.
                        Nós coletamos apenas o nome completo, endereço
                        eletrônico e outros dados pessoais necessários de você,
                        pai/mãe ou responsável, e nunca diretamente da criança.
                    </p>

                    <p>
                        1.5.3 Além disso, no caso improvável dos bens da
                        Discovery - ou grande parte deles – relativos ao Site
                        serem vendidos ou transferidos para uma outra empresa,
                        todos os Dados Pessoais coletados pela Discovery podem
                        ser transferidos para essa nova parte. Finalmente, nós
                        poderemos disponibilizar os Dados Pessoais para
                        terceiros, caso isso seja necessário para o cumprimento
                        da lei (incluindo ordens judiciais ou intimações), de
                        exigências feitas por órgãos da administração direta ou
                        indireta, para terceiros responsáveis por fazer cumprir
                        nossos Termos e Condições, ou ainda para proteger nossos
                        direitos, privacidade, segurança ou propriedades de
                        nossos funcionários ou outros usuários de nosso Site,
                        para proteger nossas operações e para permitir que
                        possamos remediar ou limitar os prejuízos que possam vir
                        a ocorrer.
                    </p>

                    <h3>1.6 Dados Não Pessoais</h3>

                    <p>
                        A Discovery mantém registrados alguns Dados Não
                        Pessoais, como o número de acessos que nosso Site recebe
                        e outras informações agregadas. Nós não associamos essas
                        informações agregadas com qualquer Dado Pessoal.
                        Terceiros que nos ajudam a administrar nosso Site podem
                        ter acesso a esses Dados Não Pessoais, bem como dados
                        agregados, assim como nossos anunciantes.
                    </p>

                    <h3>1.7 Publicidade</h3>

                    <p>
                        1.7.1 Nosso Site contém publicidade. Caso a criança
                        clique em qualquer banner ou vídeo publicitário, ela
                        deixará o ambiente protegido do Site, diretamente para o
                        website de um patrocinador. Toda vez que a criança
                        clicar em uma peça publicitária e for redirecionada para
                        outro website que não controlamos, ela será informada
                        que está deixando nosso Site . Repare que nossos
                        patrocinadores ou anunciantes podem deixar registrados
                        seus próprios cookies no seu navegador, um processo que
                        não podemos controlar.
                    </p>

                    <h3>1.8 Autenticação</h3>

                    <p>
                        1.8.1 Nosso Site pode conter oferta de vídeos
                        autenticados, ou seja, podemos ofertar vídeos para
                        assinantes de prestadoras de serviço de televisão por
                        assinatura e/ou de provedores de conexão à Internet e/ou
                        outros de serviços de parceiros comerciais.
                        Solicitaremos aos assinantes os dados mínimos
                        necessários para que seja possível a sua autenticação.
                        Os dados solicitados para tal autenticação serão os
                        dados do possuidor da assinatura com tal prestadora de
                        serviço de televisão por assinatura e/ou provedor de
                        conexão à Internet e/ou prestador de outros serviços de
                        parceiros comerciais e poderão incluir nome e e-mail,
                        país de onde está acessando o conteúdo, entre outros
                        itens necessários à autenticação. Tal oferta de vídeo ou
                        aplicativo poderá conter a possibilidade de criação de
                        um ou mais perfis de usuários da oferta, sendo que o pai
                        ou responsável poderá criar um perfil para a criança,
                        utilizando seu primeiro nome ou um nome fictício, sua
                        idade e gênero.
                    </p>

                    <h3>1.9 Direitos dos pais e responsável legal</h3>

                    <p>
                        1.9.1 Nós queremos que você se sinta seguro em relação
                        ao que o seu filho / criança pela qual é responsável
                        legal faz em nosso Site. Você pode contatar a Discovery
                        a qualquer momento, através do e-mail
                        protecaodados@discovery.com, para esclarecer dúvidas
                        sobre as informações que nós coletamos.
                    </p>

                    <h2>
                        C. INFORMAÇÕES GERAIS DE PRIVACIDADE SOBRE DADOS DE
                        USUÁRIOS MAIORES DE 12 ANOS
                    </h2>

                    <h3>
                        2.1 Esta seção da Política de Privacidade faz referência
                        à coleta de dados de usuários maiores de 12 anos.
                    </h3>

                    <h3>2.2 Que tipo de informação é coletada</h3>

                    <p>
                        2.2.1 As informações coletadas em nosso Site são
                        divididas em duas categorias: (1) Dados Pessoais,
                        fornecidos voluntariamente por usuários do Site através
                        de registros opcionais ou outros métodos; (2) Dados Não
                        Pessoais, que são captados através da navegação em nosso
                        Site e informações fornecidas pelos nossos usuários.
                    </p>

                    <h3>2.3 Dados Pessoais</h3>

                    <p>
                        2.3.1 “Dados Pessoais” são dados utilizados para
                        identificar você, como seu nome, endereço, número de
                        telefone, endereço de e-mail, idade, gênero e país de
                        onde está acessando o conteúdo, quando associados aos
                        seus dados.
                    </p>

                    <p>
                        2.3.2 A Discovery coleta e guarda os Dados Pessoais que
                        nos foram fornecidos em nosso Site. Caso você prefira
                        deixar de fornecer Dados Pessoais, você poderá utilizar
                        as partes abertas de nosso Site de forma anônima. Você
                        tem a liberdade de usufruir de alguns conteúdos abertos
                        de nosso Site, sem a necessidade de cadastro.
                    </p>

                    <p>
                        Existe uma série de atividades e conteúdos divertidos e
                        úteis em nosso Site, que exigem o fornecimento de Dados
                        Pessoais, em especial a oferta de vídeos autenticados
                        (ver item 2.10.1) e as malas diretas (newsletters) via
                        e-mail.
                    </p>

                    <p>
                        2.3.3 Quanto mais Dados Pessoais você passar, mais
                        teremos a oferecer. Fornecer esse tipo de informação é
                        um ato totalmente voluntário. A Discovery poderá
                        solicitar Dados Pessoais nas seguintes situações:
                    </p>

                    <ul>
                        <b>
                            <li>
                                Caso você tenha interesse em receber nosso
                                newsletter online, solicitaremos seu endereço de
                                e-mail, além de seu nome e sobrenome;
                            </li>
                            <li>
                                Caso você entre em contato conosco, nós podemos
                                solicitar o seu endereço de e-mail, além de
                                informações para confirmação de sua identidade;
                            </li>
                            <li>
                                Caso você tenha interesse em participar de
                                eventos, concursos ou promoções, nós
                                solicitaremos seu nome e sobrenome, bem como
                                endereço de e-mail e data de nascimento;
                            </li>
                            <li>
                                Caso você se inscreva em um dos perfis da
                                Discovery em mídias sociais, como o Facebook,
                                podemos solicitar seu endereço de e-mail e
                                outras informações de seu perfil público;
                            </li>
                            <li>
                                Caso você venha a instalar o aplicativo de
                                oferta de vídeo autenticado ou utilizar partes
                                do Site que necessitem de autenticação, podemos
                                solicitar, além de seu endereço de e-mail,
                                informações que permitam a correta identificação
                                do usuário.
                            </li>
                        </b>
                    </ul>

                    <h3>2.4 Dados Não Pessoais</h3>

                    <p>
                        2.4.1 Nós e/ou nossos provedores terceirizados de
                        serviços coletamos Dados Não Pessoais, os quais não
                        identificam o usuário quando ele interage com nosso
                        Site. Dados Não Pessoais são dados técnicos ou
                        demográficos que não te identificam pessoalmente ou que
                        não estão vinculados a você. Estas informações NÃO o
                        identificam pessoalmente. Abaixo estão exemplos de como
                        essas informações são coletadas e como podem ser
                        utilizadas.
                    </p>

                    <p>Endereço IP e demais dados de servidor</p>
                    <p>
                        Os nossos servidores coletam automaticamente informações
                        do seu computador quando você visita nosso Site,
                        incluindo o seu endereço IP. O seu endereço IP é um
                        número que permite que o computador conectado à Internet
                        saiba para onde devem ser enviadas as informações – como
                        a página da web que você está visitando. A Discovery não
                        é capaz de identificar o usuário pessoalmente a partir
                        do endereço IP. Nós usamos essa informação para que você
                        visualize nossas páginas quando solicitadas, para
                        dimensionar nosso Site conforme os interesses dos
                        usuários e para medir o tráfego de nosso Site.
                    </p>

                    <p>
                        Coletamos também os registros de servidor, ou seja,
                        verificamos quais são as páginas por você acessadas por
                        meio do seu IP. Em geral, essas informações incluem além
                        do IP, o tipo de navegador, o idioma do navegador, a
                        data e a hora em que as páginas foram acessadas e os
                        cookies que podem identificar o navegador. Desta
                        maneira, temos acesso a detalhes de como você navegou
                        por nosso Site, ou ainda registros de telefonia (caso
                        você tenha acessado nosso Site por meio de um aparelho
                        celular).
                    </p>

                    <p>2.4.1.2 Cookies</p>
                    <p>
                        Nós utilizamos um recurso padrão encontrado em seu
                        navegador de Internet chamado “cookie”, para registrar
                        cada usuário individualmente. É um número de
                        identificação anônimo e aleatório que fica registrado em
                        seu computador. É um pequeno arquivo de texto que pode
                        ser utilizado para coletar informação sobre sua
                        atividade no Site. A Discovery não é capaz de
                        identificar o usuário a partir dos cookies,
                        identificando apenas o computador usado para acessar o
                        nosso Site. Um cookie não pode acessar outros dados
                        existentes em seu dispositivo.
                    </p>

                    <p>
                        Os cookies geralmente são usados para que possamos
                        adaptar um site às suas necessidades, e para que
                        possamos fornecer um serviço melhor e personalizado, mas
                        no caso específico deste Site, utilizamos cookies apenas
                        para cumprimento de obrigação legal consistente na
                        coleta de número IP, data e hora de acesso a determinada
                        página.{' '}
                    </p>

                    <p>
                        Caso pretenda restringir, bloquear ou remover cookies,
                        veja as definições de seu navegador. Dependendo do
                        navegador, os comandos podem variar. Para gerir os
                        cookies no seu navegador móvel, recomendamos que
                        consulte o manual do seu aparelho.
                    </p>

                    <p>
                        Ao usar o Site sem restringir a ferramenta de cookies
                        e/ou outras tecnologias semelhantes, os usuários estão
                        cientes de que essas tecnologias serão utilizadas para a
                        coleta e o tratamento dos dados.
                    </p>

                    <p>2.4.1.3 Web Beacons</p>
                    <p>
                        Nós (ou os nossos provedores de serviços terceirizados)
                        podemos usar uma tecnologia de software chamada “web
                        beacons” (também conhecido como “clear gifs”, “web bugs”
                        ou “pixel tags”) ou outras tecnologias similares
                        conectadas ao nosso Site. Web beacons são pequenos
                        gráficos com uma identificação única, com função similar
                        aos cookies. Eles são usados para permitir que nós
                        possamos contar quantos usuários visitaram páginas
                        específicas de nosso Site, e para ajudar a determinar a
                        eficácia de anúncios e campanhas publicitárias. Quando
                        usado no formato de e-mails HTML, os web beacons
                        informam ao remetente se e quando o e-mail foi aberto.
                        Ao contrário dos cookies, que são armazenados no disco
                        rígido do usuário, os web beacons são invisíveis e ficam
                        embutidos nas páginas da Internet. Os web beacons não
                        coletam Dados Pessoais.
                    </p>

                    <p>2.4.1.4 Informações Demográficas</p>

                    <p>
                        Nós também coletamos Dados Não Pessoais quando
                        fornecidos voluntariamente e que não são vinculados ao
                        usuário identificado (como gênero, idade, CEP,
                        interesses pessoais em ciências, animais, natureza,
                        viagens, esportes, livros, programas de televisão,
                        etc.). Nós podemos usar essas informações para lhe
                        oferecer serviços personalizados. Por exemplo, nós
                        podemos oferecer programações de televisão
                        personalizadas e lembretes de programas do Discovery
                        Channel, TLC, Discovery Home & Health, Animal Planet,
                        Discovery Kids, Discovery Turbo ou qualquer outra oferta
                        de nossos canais, se você nos disser quais os programas
                        e tópicos que mais lhe interessam. Vale lembrar que as
                        informações agregadas são consideradas como Dados Não
                        Pessoais sempre que desvinculadas de uma pessoa
                        identificada.
                    </p>

                    <h3>
                        2.5 COMO OS DADOS COLETADOS EM NOSSO SITE SÃO USADOS E
                        COMPARTILHADOS
                    </h3>

                    <p>2.5.1 DADOS PESSOAIS</p>

                    <p>
                        2.5.1.1 OS DADOS PESSOAIS PODEM SER USADOS PARA: (I)
                        ENVIAR ALERTAS DE OFERTAS ESPECIAIS, INFORMAÇÕES
                        ATUALIZADAS E NOVOS PRODUTOS E SERVIÇOS DA DISCOVERY, OU
                        DE TERCEIROS, OU AINDA PARA ENVIAR MATERIAIS
                        PROMOCIONAIS; (II) PREENCHER OU COMPLETAR UM PEDIDO OU
                        TRANSAÇÃO FEITO PELO PRÓPRIO USUÁRIO; (III) TER ACESSO
                        AO APLICATIVO DE VÍDEO AUTENTICADO OU PARA O
                        FORNECIMENTO DE ALGUM OUTRO SERVIÇO; (IV) VIABILIZAR A
                        PARTICIPAÇÃO EM EVENTOS DA DISCOVERY OU PARA CUMPRIR COM
                        OS TERMOS DE UMA PROMOÇÃO; (V) GARANTIR QUE O SITE SEJA
                        RELEVANTES PARA SUAS NECESSIDADES; (VI) AUXILIAR A
                        DISCOVERY A CRIAR E PUBLICAR CONTEÚDOS MAIS RELEVANTES
                        PARA OS USUÁRIOS; (VII) ENTRAR EM CONTATO COM OS
                        USUÁRIOS EM RESPOSTA A FORMULÁRIOS DE INSCRIÇÃO, TAIS
                        COMO “FALE CONOSCO”; (IX) PERMITIR O ACESSO A ÁREAS
                        RESTRITAS DO SITE. NÓS TAMBÉM PODEMOS USAR SEUS DADOS
                        PESSOAIS PARA CONFIRMAR O SEU CADASTRO NO SITE,
                        INFORMÁ-LO SOBRE MUDANÇAS EM NOSSA POLÍTICA DE
                        PRIVACIDADE E/OU EM NOSSOS TERMOS E CONDIÇÕES.
                    </p>

                    <p>
                        2.5.1.2. NÓS TAMBÉM PODEMOS COMPARTILHAR DADOS PESSOAIS
                        COM SERVIÇOS DE TERCEIROS QUE NOS AJUDAM A MANTER NOSSO
                        SITE E FORNECER OUTROS SERVIÇOS ADMINISTRATIVOS
                        (INCLUINDO, ENTRE OUTRAS COISAS, O PROCESSAMENTO DE UM
                        PEDIDO E A SUA REALIZAÇÃO, FORNECIMENTO DE SERVIÇOS AO
                        CONSUMIDOR, MANUTENÇÃO E ANÁLISE DE DADOS, ENVIO DE
                        INFORMAÇÕES, DADOS DE INSCRIÇÃO, SELEÇÃO DE GANHADORES E
                        ENTREGA DE PRÊMIOS AOS VENCEDORES, CONCURSOS E OUTRAS
                        PROMOÇÕES, PARTICIPAÇÃO EM EVENTOS).
                    </p>

                    <p>
                        2.5.1.3. NÓS TRABALHAMOS PARA GARANTIR QUE TERCEIROS NÃO
                        USEM OS DADOS PESSOAIS PARA QUALQUER OUTRO PROPÓSITO,
                        SENÃO FORNECER OS SERVIÇOS ADMINISTRATIVOS PELOS QUAIS
                        SÃO RESPONSÁVEIS. COMO OS PROVEDORES DE ACESSO
                        TERCEIRIZADOS, QUE NOS AJUDAM NA ADMINISTRAÇÃO DO SITE,
                        ELES TÊM ACESSO AOS DADOS PESSOAIS DOS USUÁRIOS. SE VOCÊ
                        PREFERIR QUE TERCEIROS NÃO TENHAM ACESSO AOS SEUS DADOS
                        PESSOAIS, POR FAVOR, NÃO FAÇA O CADASTRO NEM SUBMETA
                        QUALQUER DADO PESSOAL PARA NÓS. VOCÊ SEMPRE TEM A OPÇÃO
                        DE NÃO FORNECER OS DADOS QUE PEDIMOS E USAR NOSSO
                        WEBSITE DE FORMA ANÔNIMA, PARA ACESSO A CONTEÚDOS NA
                        PARTE EM QUE É ABERTA. ALÉM DISSO, CASO VOCÊ TENHA
                        FORNECIDO OS DADOS E GOSTARIA QUE ELES FOSSEM EXCLUÍDOS,
                        BASTA ACESSAR, AO FINAL DA PÁGINA DO SITE, O BOTÃO QUE
                        SOLICITA QUE OS DADOS SEJAM APAGADOS.
                    </p>

                    <p>
                        2.5.1.4. OCASIONALMENTE, A DISCOVERY PODE OFERECER
                        CONCURSOS OU OUTRAS PROMOÇÕES EM NOSSO SITE PARA PESSOAS
                        ENTRE 12 E 18 ANOS. NESSE CASO, É POSSÍVEL QUE SUA
                        PARTICIPAÇÃO DEPENDA DE APROVAÇÃO DE SEUS RESPONSÁVEIS
                        LEGAIS, CASO EM QUE VOCÊ TERÁ DE FORNECER, ALÉM DE SEUS
                        DADOS PESSOAIS, TAMBÉM OS DADOS PESSOAIS DE SEUS
                        RESPONSÁVEIS LEGAIS, COMO NOME, ENDEREÇO, E/OU E-MAIL,
                        PARA QUE POSSAMOS OBTER AS AUTORIZAÇÕES SOLICITADAS POR
                        LEI (SE NECESSÁRIO) E, EVENTUALMENTE, ENTRAR EM CONTATO
                        COM VOCÊ, CASO SEJA O VENCEDOR. NÓS PODEMOS COMPARTILHAR
                        ESSES DADOS PESSOAIS, TANTO OS DE VOCÊS QUANTO OS DE
                        SEUS RESPONSÁVEIS LEGAIS, COM OS PATROCINADORES DO
                        CONCURSO (COMO DESCRITO NAS REGRAS APLICADAS A UMA
                        PROMOÇÃO OU CONCURSO EM PARTICULAR). PEDIMOS TAMBÉM QUE
                        LEIA AS REGRAS DA PROMOÇÃO/CONCURSO COM MUITO CUIDADO.
                        ELAS PODEM CONTER INFORMAÇÕES IMPORTANTES SOBRE COMO NÓS
                        E NOSSOS PATROCINADORES USAMOS OS SEUS DADOS PESSOAIS.
                        PARA EVITAR CONFLITOS ENTRE AS REGRAS DE UM CONCURSO E
                        ESTA POLÍTICA DE PRIVACIDADE, AS REGRAS APLICADAS A UM
                        CONCURSO OU PROMOÇÃO EM PARTICULAR SEMPRE PREVALECEM.
                    </p>

                    <p>
                        2.5.1.5. NO CASO DE CONCURSOS OU OUTRAS PROMOÇÕES EM
                        NOSSO SITE PARA PESSOAS ACIMA DE 18 ANOS, NÃO SERÃO
                        SOLICITADOS OS DADOS PESSOAIS DE SEUS RESPONSÁVEIS
                        LEGAIS, NO ENTANTO, O DISPOSTO ACIMA SE APLICA PARA SEUS
                        DADOS PESSOAIS.
                    </p>

                    <p>
                        2.5.1.6. TAMBÉM PODEMOS COMPARTILHAR DADOS PESSOAIS DE
                        MAIORES DE IDADE COM OPERADORES DE TELEVISÃO POR
                        ASSINATURA, PROVEDORES DE CONEXÃO COM INTERNET,
                        PARCEIROS ESTRATÉGICOS, PROFISSIONAIS DE MARKETING DE
                        TERCEIROS OU TERCEIROS QUE ESTEJAM OFERECENDO PRODUTOS
                        OU SERVIÇOS QUE ACREDITAMOS QUE POSSAM SER DE SEU
                        INTERESSE OU QUE NECESSITEM DE SUAS INFORMAÇÕES PESSOAIS
                        PARA PESQUISA, PARA FINS COMERCIAIS INTERNOS E/OU
                        ADMINISTRATIVOS. TAIS TERCEIROS PODEM UTILIZAR SEUS
                        DADOS PESSOAIS PARA CONTATÁ-LO COM UMA OFERTA OU
                        PROPAGANDA RELACIONADA A UM PRODUTO OU SERVIÇO, OU PODEM
                        UTILIZAR ESSES DADOS PARA SEUS PRÓPRIOS FINS DE
                        PESQUISA, ADMINISTRATIVOS OU DE NEGÓCIOS. CASO NÃO
                        QUEIRA COMPARTILHAR SEUS DADOS PESSOAIS DESTA FORMA, NÃO
                        NOS FORNEÇA ESSES DADOS.
                    </p>

                    <p>
                        2.5.1.7 CASO NOSSOS BENS – OU GRANDE PARTE DELES –
                        RELATIVOS AO SITE SEJAM VENDIDOS OU TRANSFERIDOS PARA
                        UMA OUTRA EMPRESA, TODOS OS DADOS PESSOAIS COLETADOS E
                        SALVOS PELA DISCOVERY PODEM SER TRANSFERIDAS PARA ESSA
                        NOVA PARTE.
                    </p>

                    <p>
                        2.5.1.8 NÓS PODEREMOS DISPONIBILIZAR OS DADOS PESSOAIS
                        PARA TERCEIROS, CASO ISSO SEJA NECESSÁRIO PARA O
                        CUMPRIMENTO DA LEI (INCLUINDO ORDENS JUDICIAIS OU
                        INTIMAÇÕES), PARA CUMPRIR COM AS EXIGÊNCIAS DE ÓRGÃOS DA
                        ADMINISTRAÇÃO DIRETA OU INDIRETA, INCLUSIVE DA
                        AUTORIDADE NACIONAL DE PROTEÇÃO DE DADOS, PARA FAZER
                        CUMPRIR NOSSOS TERMOS E CONDIÇÕES, PARA PROTEGER NOSSOS
                        DIREITOS, PRIVACIDADE, SEGURANÇA OU PROPRIEDADES DE
                        NOSSOS FUNCIONÁRIOS OU DE OUTROS USUÁRIOS DE NOSSO SITE,
                        PARA PROTEGER NOSSAS OPERAÇÕES E PARA PERMITIR QUE
                        POSSAMOS REMEDIAR OU LIMITAR EVENTUAIS PREJUÍZOS QUE
                        POSSAM VIR A OCORRER.
                    </p>

                    <p>
                        2.5.1.9. PODEMOS TAMBÉM UTILIZAR SEUS DADOS PESSOAIS E
                        NÃO PESSOAIS PARA PROTEÇÃO CONTRA POSSÍVEIS FRAUDES AO
                        SITE. PARA ISSO, PODEMOS VERIFICAR COM TERCEIROS OS
                        DADOS COLETADOS A PARTIR DO SITE. DURANTE TAL
                        VERIFICAÇÃO, PODEMOS RECEBER DADOS PESSOAIS A SEU
                        RESPEITO A PARTIR DE TAIS SERVIÇOS. ESPECIALMENTE NO
                        CASO DE UTILIZAR OS SERVIÇOS DE OFERTA DE VÍDEOS
                        AUTENTICADOS, CASO EM QUE PODEMOS VERIFICAR COM SUA
                        PRESTADORA DE SERVIÇO DE TELEVISÃO POR ASSINATURA E/OU
                        PROVEDOR DE CONEXÃO À INTERNET SE SEUS DADOS ESTÃO
                        CORRETOS.
                    </p>

                    <p>
                        2.5.1.10. SALVO ESTIPULAÇÃO EM CONTRÁRIO PREVISTA NESTA
                        POLÍTICA DE PRIVACIDADE OU NO MOMENTO EM QUE
                        SOLICITARMOS OS DADOS, NÃO UTILIZAMOS, COMPARTILHAMOS OU
                        DIVULGAMOS DE OUTRA FORMA SEUS DADOS PESSOAIS A
                        TERCEIROS.
                    </p>

                    <p>2.5.2 DADOS NÃO PESSOAIS</p>

                    <p>
                        2.5.2.1 NÓS NOS RESERVAMOS O DIREITO DE USAR OS DADOS
                        NÃO PESSOAIS PARA QUALQUER PROPÓSITO, EM QUALQUER PAÍS
                        DO MUNDO, INCLUINDO O COMPARTILHAMENTO COM TERCEIROS,
                        TAIS COMO NOSSOS AFILIADOS, PARCEIROS ESTRATÉGICOS,
                        DENTRE OUTROS. POR EXEMPLO, NÓS PODEMOS APRESENTAR
                        INFORMAÇÕES, COMO ESTATÍSTICAS AGREGADAS DE TRÁFEGO DAS
                        DIVERSAS PÁGINAS DE NOSSO SITE, PARA OS NOSSOS
                        ANUNCIANTES, COM A FINALIDADE DE AJUDÁ-LOS A ANALISAR
                        NOSSA AUDIÊNCIA E CONFIRMAR O VALOR DE UM ANÚNCIO EM
                        NOSSO SITE. NO CASO DE UMA COMBINAÇÃO DE DADOS NÃO
                        PESSOAIS COM DADOS PESSOAIS, ESSA COMBINAÇÃO SERÁ
                        TRATADA COMO DADOS PESSOAIS ENQUANTO ELAS ESTIVEREM
                        COMBINADAS E ASSOCIADAS A UM TITULAR DE DADOS.
                    </p>

                    <p>
                        CASO NOSSOS BENS – OU GRANDE PARTE DELES – RELATIVOS AO
                        SITE SEJAM VENDIDOS OU TRANSFERIDOS PARA UMA OUTRA
                        EMPRESA, TODOS OS DADOS NÃO PESSOAIS COLETADOS E
                        ARMAZENADOS PELA DISCOVERY PODEM SER TRANSFERIDOS PARA
                        ESSA NOVA PARTE.
                    </p>

                    <h3>
                        2.6 COMPARTILHAMENTO INTERNACIONAL DE DADOS PESSOAIS
                    </h3>

                    <p>
                        2.6.1 CASO VOCÊ OPTE POR NOS FORNECER SEUS DADOS
                        PESSOAIS, A DISCOVERY PODERÁ COMPARTILHAR ESTES DADOS
                        COM SUBSIDIÁRIAS E EMPRESAS DE SEU GRUPO ECONÔMICO, BEM
                        COMO COM TERCEIROS, ALÉM DAS FRONTEIRAS DE SEU PAÍS OU
                        JURISDIÇÃO, PARA OUTROS PAÍSES OU JURISDIÇÕES AO REDOR
                        DO MUNDO, EM ESPECIAL PARA O ESTADOS UNIDOS DA AMÉRICA,
                        EM TODOS OS CASOS, SEMPRE (I) PARA PAÍSES QUE CONTENHAM
                        PROTEÇÃO LEGAL NO MÍNIMO TÃO RESTRITA QUANTO À PREVISTA
                        NA LEGISLAÇÃO BRASILEIRA, TAL COMO VENHA A SER
                        DETERMINADO PELA AUTORIDADE NACIONAL DE PROTEÇÃO DE
                        DADOS E/OU (II) PARA OS DEMAIS PAÍSES, UTILIZANDO OS
                        MECANISMOS DE TRANSFERÊNCIA DE DADOS APROPRIADOS, DE
                        ACORDO COM O QUE VENHA A SER REGULAMENTADO PELA
                        AUTORIDADE NACIONAL DE PROTEÇÃO DE DADOS.
                    </p>

                    <h3>
                        <b>
                            2.7 Fóruns, salas de bate-papo e outras áreas de
                            postagens públicas
                        </b>
                    </h3>

                    <p>
                        2.7.1 Vale lembrar que qualquer informação que você
                        coloque em uma mensagem de uma sala de bate-papo, fórum
                        ou de qualquer outra área pública de postagem que
                        eventualmente exista em nosso Site, estará disponível
                        para qualquer pessoa que tenha acesso à Internet. Se
                        você não quer que outra pessoa saiba o seu e-mail, por
                        exemplo, não o inclua em qualquer mensagem que faça
                        parte de uma postagem pública. Nós recomendamos que você
                        seja discreto e cauteloso quando decidir revelar
                        qualquer dado pessoal, ou qualquer outra informação, em
                        qualquer sala de bate-papo, fórum ou áreas de postagem
                        pública. POR FAVOR, SEJA EXTREMAMENTE CAUTELOSO QUANDO
                        REVELAR QUALQUER INFORMAÇÃO EM SALAS DE BATE-PAPO,
                        FÓRUNS E OUTRAS ÁREAS DE POSTAGEM PÚBLICAS. NÓS NÃO NOS
                        RESPONSABILIZAMOS CASO OUTRA PESSOA USE OS DADOS OU AS
                        INFORMAÇÕES QUE VOCÊ DISPONIBILIZOU PUBLICAMENTE EM
                        ALGUNS DESSES MEIOS.
                    </p>

                    <h3>2.8 Website de terceiros</h3>

                    <p>
                        2.8.1 Você deve ter reparado que nosso Site inclui links
                        para outros websites que não fazem parte da nossa
                        Política de Privacidade. Por exemplo, você pode entrar
                        no link de um patrocinador. Uma vez fora de nossos
                        servidores (você pode checar em que domínio está,
                        olhando a barra de endereços na parte de cima do seu
                        navegador), o uso de qualquer informação que você
                        fornecer em outro website está sujeito à política de
                        privacidade do website que você está visitando. Essas
                        empresas podem ter políticas de privacidade e práticas
                        diferentes das nossas. Se você não conseguir achar a
                        política de privacidade através de um link na página
                        principal do website visitado, nós sugerimos que entre
                        em contato diretamente com o responsável pelo website
                        visitado para obter mais informações. Nós recomendamos
                        que todos tenham precaução no entendimento de como as
                        suas informações são coletadas e usadas pelos websites.
                        Nós não nos responsabilizamos pelas políticas de
                        privacidade ou pelo conteúdo de websites de terceiros.
                    </p>

                    <h3>2.9 Publicidade</h3>

                    <p>
                        2.9.1 Nosso Site contém publicidade. Utilizamos os dados
                        que coletamos de adultos para ajudar a selecionar os
                        anúncios disponibilizados em nossos serviços ou em
                        serviços disponibilizados por terceiros. Os anúncios que
                        selecionamos podem ser baseados em sua localização
                        atual, consulta de pesquisa ou nos conteúdos que você
                        está visualizando. Outros anúncios são selecionados com
                        base em interesses mais prováveis ou outras informações
                        às quais tenhamos tido acesso ao longo do tempo, através
                        de dados demográficos, consultas de pesquisa, interesses
                        e favoritos, dados de utilização e dados de localização.
                    </p>
                    <p>
                        Caso você clique no banner ou no vídeo publicitário,
                        deixará o Site diretamente para o website de tal
                        patrocinador. Repare que nossos patrocinadores, ou
                        anunciantes terceirizados, podem deixar registrados seus
                        próprios cookies no seu navegador, um processo que não
                        podemos controlar.
                    </p>
                    <p>
                        Ademais, podemos utilizar redes de publicidade de
                        terceiros e outras empresas de publicidade podem coletar
                        informações sobre a sua visita ao Site (como por meio de
                        cookies, web beacons e outras tecnologias), exceto com
                        relação aos dados pessoais de crianças, para permitir
                        que terceiros ofereçam produtos ou serviços ou
                        publicidade para você, para monitorar quais os anúncios
                        foram servidos ao seu navegador e quais páginas da web
                        você está vendo quando estes anúncios forem entregues.
                    </p>

                    <h3>2.10 Autenticação</h3>

                    <p>
                        2.10.1 Nosso Site pode conter oferta de vídeos
                        autenticados, ou seja, podemos ofertar vídeos para
                        assinantes de prestadoras de serviço de televisão por
                        assinatura, de provedores de conexão à Internet e/ou
                        outros parceiros comerciais. Solicitaremos aos
                        assinantes de tais serviços apenas os dados necessários
                        para que seja possível a sua autenticação. Os dados
                        solicitados para tal autenticação serão os dados do
                        possuidor da assinatura com tal prestadora de serviço de
                        televisão por assinatura, provedor de conexão à Internet
                        e/ou parceiro comercial, podendo incluir nome inteiro,
                        e-mail, país de onde está acessando o conteúdo, entre
                        outras informações que sejam necessárias para a correta
                        identificação do usuário e respectiva autenticação. Tal
                        oferta de vídeo ou aplicativo poderá conter a
                        possibilidade de criação de um ou mais perfis de
                        usuários da oferta.
                    </p>

                    <h2>D. ALTERAÇÕES A ESTA POLÍTICA DE PRIVACIDADE</h2>

                    <p>
                        Nós podemos modificar esta Política de Privacidade de
                        tempos em tempos. Quando este for o caso, atualizaremos
                        também a data da “Última Atualização”, localizada no fim
                        desta Política de Privacidade. Em se tratando de
                        modificações que eventualmente sejam menos restritivas
                        para nós sobre o uso e compartilhamento de Dados
                        Pessoais que você nos forneceu, tal alteração será feita
                        por meio de um comunicado em nosso Site, de maneira
                        facilmente visível.
                    </p>

                    <h3>E. ARMAZENAMENTO E SEGURANÇA</h3>

                    <p>
                        A Discovery procura assegurar que os Dados Pessoais que
                        você fornece estão armazenados em ambientes seguros,
                        localizados no Brasil, Estados Unidos da America e Reino
                        Unido. Contudo, por mais que o nosso sistema seja
                        seguro, nenhum sistema de segurança é completamente
                        impenetrável. Sendo assim, não temos como garantir
                        segurança absoluta de nosso banco de dados, e nem
                        podemos garantir que os Dados Pessoais que você forneceu
                        não possam ser interceptados quando a transmissão é
                        feita pela Internet.
                    </p>
                    <p>
                        Nós utilizamos firewalls para proteger suas informações
                        de acessos não autorizados, divulgação, alteração ou
                        destruição. POR FAVOR, LEVE EM CONSIDERAÇÃO QUE ISSO NÃO
                        GARANTE QUE TAIS INFORMAÇÕES NÃO SEJAM ACESSADAS,
                        DIVULGADAS, ALTERADAS OU DESTRUÍDAS EM RAZÃO DE INVASÕES
                        EM NOSSOS FIREWALLS OU SOFTWARE DE SEGURANÇA.
                    </p>
                    <p>
                        Caso identifiquemos uma violação ou invasão em nossos
                        sistemas, adotaremos as medidas previstas em legislação
                        e regulamentações vigentes, incluindo a possibilidade de
                        notificá-lo eletronicamente para que você tome as
                        medidas protetivas que ache necessárias. Ao fornecer
                        Dados Pessoais em nosso Site, você concorda que nós
                        podemos nos comunicar com você eletronicamente sobre
                        segurança, privacidade e questões administrativas
                        relacionadas ao seu uso de nosso Site. Além disso, caso
                        ocorra uma violação ou invasão, nós podemos inserir um
                        comunicado em nosso Site, ou enviar referido comunicado
                        ao e-mail que você nos informou.
                    </p>

                    <h3>F. DIREITOS DOS USUÁRIOS </h3>

                    <p>
                        Nos termos da Lei Geral de Proteção de Dados – LGPD (Lei
                        13.709/2018), os usuários do Site têm direito a nos
                        solicitar:
                    </p>

                    <ul>
                        <b>
                            <li>
                                a confirmação de que realizamos o tratamento dos
                                seus dados;
                            </li>
                            <li>o acesso aos seus dados;</li>
                            <li>
                                a correção de dados que estejam incompletos,
                                inexatos ou desatualizados;
                            </li>
                            <li>
                                a anonimização, bloqueio ou eliminação de dados
                                desnecessários, excessivos ou tratados em
                                desconformidade com o disposto na LGPD;
                            </li>
                            <li>
                                a portabilidade dos seus dados a outro
                                fornecedor de serviço ou produto, observados os
                                nossos segredos comerciais e industriais, após a
                                regulamentação pela Autoridade Nacional de
                                Proteção de Dados – ANPD;
                            </li>
                            <li>
                                a eliminação dos dados tratados com base no seu
                                consentimento, exceto nas hipóteses de
                                conservação de dados previstas na LGPD;
                            </li>
                            <li>
                                informação sobre com quem compartilhamos seus
                                dados;
                            </li>
                            <li>
                                informação sobre a possibilidade de não fornecer
                                o seu consentimento e as consequências;
                            </li>
                            <li>
                                a revogação do seu consentimento para o
                                tratamento dos seus dados, quando os dados forem
                                tratados com base no seu consentimento.
                            </li>
                        </b>
                    </ul>

                    <p>
                        O usuário poderá exercer quaisquer dos direitos acima
                        preenchendo o formulário constante no link a seguir:{' '}
                        <b>
                            <a
                                href="https://privacyportal.onetrust.com/webform/50417659-aa29-4f7f-b59d-f6e887deed53/7b1f6a5a-2314-4d06-aec2-abf71bc3ba36"
                                target="_blank"
                            >
                                Formulário
                            </a>
                        </b>
                    </p>

                    <h3>G. EXCLUSÃO DOS DADOS</h3>

                    <p>
                        Os Dados Pessoais que coletamos são mantidos de forma
                        identificada somente durante o período em que são
                        necessários para as finalidades descritas acima, se
                        formos obrigados por lei ou se tivermos outra razão
                        legítima para mantê-los.
                    </p>
                    <p>
                        As informações que coletamos referentes ao endereço IP e
                        aos registros de acesso dos usuários cadastrados são
                        armazenadas por pelo menos 6 (seis) meses, conforme
                        determinado pelo artigo 15 do Marco Civil da Internet
                        (Lei 12.965/2014).
                    </p>

                    <h3>H. CONTATO</h3>

                    <p>
                        Se você tiver dúvidas ou perguntas em relação à Política
                        de Privacidade, se qualquer exercício de direitos não
                        puder ser efetuado por meio do formulário indicado no
                        item “F” acima, ou se, por qualquer motivo, você
                        precisar se comunicar conosco a respeito do uso das suas
                        informações, você pode entrar em contato pelo e-mail
                        protecaodados@discovery.com.
                    </p>

                    <h3>I. ENCARREGADO (DPO)</h3>

                    <p>
                        Atualmente indicamos a Equipe de Proteção de Dados do
                        escritório Baptista Luz Advogados como encarregado para
                        atuar como canal de comunicação entre a Discovery, os
                        titulares de dados e a Autoridade Nacional de Proteção
                        de Dados, o qual pode ser acessado através do e-mail
                        mencionado acima.
                    </p>

                    <p>Última atualização: 27 de agosto de 2020.</p>
                </div>
            </Container>
        );
    } else if (location.pathname.indexOf('politica-de-privacidad') > -1) {
        return (
            <Container>
                <div class="cuerpo">
                    <h1>Política de privacidad</h1>
                    <p>
                        Esta política de privacidad se aplica solo a los sitios
                        web, las aplicaciones y otras propiedades digitales
                        controladas por Discovery Communications, LLC y/o sus
                        filiales y entidades afiliadas ("Discovery", "nosotros")
                        donde se publica esta política de privacidad
                        (colectivamente, los "Sitios"). Esta política de
                        privacidad no se refiere a la información que se
                        recopila fuera de la red. AL USAR LOS SITIOS, USTED
                        ACEPTA LOS TÉRMINOS Y LAS CONDICIONES DE ESTA POLÍTICA
                        DE PRIVACIDAD Y NUESTRO PROCESAMIENTO DE INFORMACIÓN
                        PERSONAL CON LOS FINES QUE SE INDICAN A CONTINUACIÓN. SI
                        NO ESTÁ DE ACUERDO CON LOS TÉRMINOS Y LAS CONDICIONES DE
                        ESTA POLÍTICA DE PRIVACIDAD, POR FAVOR NO UTILICE LOS
                        SITIOS.
                    </p>

                    <h2>A. Información recopilada</h2>
                    <p>
                        Esta política de privacidad se aplica únicamente a la
                        información recopilada en los Sitios y no se aplica a la
                        información recopilada por Discovery a través de
                        cualquier otro medio.
                    </p>
                    <p>
                        Recopilamos dos tipos de información de las personas que
                        ingresan a los sitios: (1) información de identificación
                        personal y (2) información de identificación no
                        personal, como su dirección IP o cookies.
                    </p>
                    <h3>(1) Información de Identificación Personal</h3>
                    <p>
                        "Información de Identificación Personal" es información
                        que lo identifica personalmente, como su nombre,
                        dirección, número de teléfono, dirección de correo
                        electrónico o nombre de la empresa. Discovery recopila y
                        almacena la información de identificación personal que
                        nos ha proporcionado. Estos son algunos ejemplos de las
                        maneras en que podemos recopilar su información personal
                        en los sitios:
                    </p>
                    <ul>
                        <li>
                            Podemos recopilar su dirección de correo
                            electrónico, nombre y apellido y código postal si se
                            suscribe a un boletín en línea;
                        </li>
                        <li>
                            Podemos recopilar su correo electrónico si se
                            comunica con nosotros con una pregunta;
                        </li>
                        <li>
                            Podemos recopilar su nombre y apellido, fecha de
                            nacimiento y dirección de correo electrónico si
                            decide participar en un concurso o sorteo; y
                        </li>
                        <li>
                            Podemos recopilar su dirección de correo
                            electrónico, lugar de residencia y otra información
                            de su perfil público si se inscribe en uno de
                            nuestros sitios web a través de un sitio de redes
                            sociales como Facebook.{' '}
                        </li>
                    </ul>
                    <p>
                        La lista que antecede es un ejemplo de la información de
                        identificación personal que puede ser recopilada en los
                        Sitios. Si no quiere que Discovery recopile su
                        información de identificación personal, no proporcione
                        dicha información.
                    </p>

                    <h3>(2) Información de identificación no personal</h3>
                    <p>
                        "La información de identificación no personal" puede ser
                        información técnica o puede ser información demográfica,
                        como su edad, sexo o intereses. La información de
                        identificación no personal NO lo identifica
                        personalmente. Estos son algunos ejemplos de la
                        información de identificación no personal que se
                        recopila a través de los Sitios y una descripción de
                        cómo se utiliza esta información:
                    </p>
                    <ul>
                        <li>
                            Protocolo de Internet (IP) - Su dirección IP es un
                            número que permite a las computadoras conectadas a
                            Internet saber a dónde enviarle datos - tales como
                            las páginas web que visita. Utilizamos esta
                            información para entregar nuestras páginas web a su
                            solicitud, para adaptar nuestros sitios a los
                            intereses de nuestros usuarios y para medir el
                            tráfico en nuestros Sitios.
                        </li>
                        <li>
                            Cookie - Una "cookie" es un pequeño archivo de texto
                            que puede ser utilizado para recopilar información
                            sobre su actividad en los Sitios. Por ejemplo,
                            cuando alguien visita una página dentro de los
                            Sitios, se coloca una cookie en el ordenador del
                            usuario (si el usuario acepta las cookies) o se lee
                            si el usuario ha visitado los Sitios previamente.
                            Usted puede configurar la mayoría de los navegadores
                            para que le notifique si recibe una cookie, o puede
                            optar por bloquear las cookies de su navegador, pero
                            si lo hace, es posible que no sea capaz de
                            beneficiarse de las características personalizadas
                            que disfrutan otros usuarios de nuestros Sitios.
                        </li>
                        <li>
                            Web Beacons (también conocidos como "clear gifs",
                            "web bugs" o "pixel tags") - "Web Beacons" son
                            pequeños gráficos con un identificador único,
                            similar en función a las cookies, y se utilizan para
                            que podamos contar los usuarios que han visitado
                            ciertas páginas de los Sitios y para ayudar a
                            determinar la efectividad de las campañas
                            promocionales o publicitarias. Cuando se utiliza en
                            mensajes de correo electrónico con formato HTML, los
                            web beacons pueden decir al remitente cuando el
                            correo electrónico se ha abierto. En contraste con
                            las cookies, que se almacenan en el disco duro de la
                            computadora de un usuario, los web beacons están
                            incrustados invisiblemente en las páginas web.
                        </li>
                        <li>
                            Información Demográfica - "Información Demográfica"
                            puede ser su sexo, edad, código postal e intereses
                            personales, que nos proporciona voluntariamente en
                            los Sitios. Utilizamos esta información para
                            ofrecerle servicios personalizados y analizar las
                            tendencias, para garantizar que la información
                            proporcionada por los Sitios se adapte a sus
                            necesidades. Por ejemplo, ofrecemos listados de
                            programación de TV personalizados y recordatorios de
                            programas de Discovery Channel, Discovery Kids,
                            Discovery Home &amp; Health, TLC, Animal Planet, o
                            cualquiera de nuestras otras ofertas de televisión
                            si nos dice cuáles son los programas y temas en los
                            que está interesado. Tenga en cuenta que también
                            consideramos que la información agregada, que no es
                            de identificación personal, es información de
                            identificación no personal. La lista que antecede es
                            un ejemplo de la información de identificación no
                            personal que se recopila a través de los Sitios.
                        </li>
                    </ul>

                    <h2>
                        B. Uso de la información recopilada a través de los
                        Sitios
                    </h2>
                    <h3>(1) Información de Identificación Personal</h3>
                    <p>
                        Utilizamos su información de identificación personal,
                        que se recopila en nuestros Sitios, principalmente para
                        los siguientes fines:
                    </p>
                    <ul>
                        <li>
                            Para prestar servicios, como programas educativos,
                            información, boletines de noticias o software que
                            usted solicita o compra;
                        </li>
                        <li>
                            Para avisarle de información actualizada y otros
                            nuevos servicios de Discovery o de terceros, o para
                            enviar material promocional;
                        </li>
                        <li>
                            Para completar una transacción o servicio solicitado
                            por usted;
                        </li>
                        <li>Para cumplir con los términos de una promoción;</li>
                        <li>
                            Para asegurar que los Sitios son relevantes para sus
                            necesidades;
                        </li>
                        <li>
                            Para ayudarnos a crear y publicar contenido más
                            relevante para usted;
                        </li>
                        <li>
                            Para notificarle acerca de un cambio sustancial en
                            esta política de privacidad o el Acuerdo del
                            Visitante, si es necesario;
                        </li>
                        <li>
                            Para permitir el acceso a las áreas de entrada
                            limitada de los Sitios; y
                        </li>
                        <li>
                            Para contactarlo en respuesta a formularios de
                            registro, tales como Contáctenos o Consulta sobre
                            Pedidos.
                        </li>
                    </ul>
                    <h3>(2) Información de identificación no personal</h3>
                    <p>
                        La información de identificación no personal se utiliza
                        como se ha descrito anteriormente y de otras maneras
                        según lo permitido por las leyes aplicables, incluyendo
                        la combinación de información de identificación no
                        personal con información de identificación personal
                        (excepto con respecto a la información de identificación
                        no personal recopilada de niños menores de 13 años).
                    </p>

                    <h2>C. Intercambio y divulgación de información</h2>
                    <h3>(1) Información de Identificación Personal</h3>
                    <p>
                        Podemos compartir o divulgar su información de
                        identificación personal en los siguientes casos:
                        <br />
                        (i) Para brindarle un servicio. Por ejemplo, si elige
                        ver un programa educativo en los Sitios, podemos
                        compartir su información de identificación personal con
                        el fin de poner el programa a su disposición. Además, si
                        nos envía por correo electrónico una pregunta, podemos
                        utilizar su dirección de correo electrónico para
                        procesar su solicitud y responder a su pregunta. Además,
                        si está entrando en un sorteo o concurso, podemos usar
                        su información de identificación personal con el fin de
                        cumplir con los términos de dicha promoción. Esto
                        significa que es posible que compartamos la información
                        con fines de la entrega del premio o de correspondencia.
                        También podemos compartir su información con el
                        co-patrocinador de esa promoción.
                        <br />
                        <br />
                        (ii) Para los afiliados, socios estratégicos, agentes,
                        empresas de marketing de terceros u otras partes no
                        afiliadas que están ofreciendo productos o servicios que
                        creemos que pueden ser de su interés o que requieren su
                        información de identificación personal con fines de
                        investigación, administrativos y/o comerciales internos.
                        Los terceros pueden utilizar su información de
                        identificación personal para enviarle una oferta o
                        publicidad relacionada con un producto o servicio, o
                        pueden utilizar dicha información para sus propios fines
                        de investigación, administrativos o comerciales. Si no
                        desea que compartamos su información de identificación
                        personal de esta manera, le solicitamos que no nos
                        proporcione esta información.
                        <br />
                        <br />
                        (iii) Para los proveedores de servicios de terceros,
                        agentes o contratistas independientes no afiliados, que
                        nos ayudan a mantener nuestros Sitios y nos proporcionan
                        otros servicios administrativos (incluyendo, de modo no
                        taxativo, , prestación de servicios al cliente,
                        mantenimiento y análisis de datos, envío de
                        comunicaciones a los clientes en nombre de Discovery y
                        recopilación de inscripciones, selección de ganadores y
                        entrega de premios de concursos, sorteos y otras
                        promociones). Intentamos asegurarnos de que estos
                        terceros no afiliados no utilicen la información de
                        identificación personal para ningún otro propósito que
                        el de proporcionar los servicios administrativos de los
                        que son responsables. Debido a que estos proveedores de
                        servicios de terceros no afiliados que nos ayudan a
                        administrar nuestros Sitios tendrán acceso a la
                        información de identificación personal de los usuarios,
                        si no desea que nuestros proveedores de servicios de
                        terceros no afiliados tengan acceso a su información, le
                        solicitamos que no se registre, ni nos envíe información
                        de identificación personal.
                        <br />
                        <br />
                        (iv) Para cumplir con la ley o en la creencia de buena
                        fe, que dicha acción es necesaria para cumplir con los
                        requisitos legales o cumplir un proceso jurídico con
                        respecto al cual estemos citados, proteger y defender
                        nuestros derechos o bienes, incluyendo los derechos y
                        los bienes de Discovery y su familia de sitios, o actuar
                        en circunstancias urgentes para proteger la seguridad
                        personal de nuestros usuarios finales.
                        <br />
                        <br />
                        (v) Para terceros como parte de cualquier proceso de
                        reorganización corporativa, incluyendo, de modo no
                        taxativo, las fusiones, adquisiciones y ventas de todos
                        o sustancialmente todos nuestros activos.
                        <br />
                        <br />
                        (vi) Para realizar un seguimiento y analizar la
                        información, no de identificación y agregada,
                        estadística de volumen y uso, de nuestros visitantes y
                        clientes y proporcionar dicha información a terceros.
                        <br />
                        <br />
                        (vii) Para protegernos contra posible fraude, podemos
                        verificar con terceros la información obtenida de estos
                        Sitios. En el transcurso de dicha verificación, podemos
                        recibir información de información personal sobre usted
                        derivada de estos servicios. <br />
                        <br />
                        Excepto como se describe en esta Política de Privacidad,
                        o en el momento que solicitamos la información, no
                        utilizamos, compartimos ni revelamos de otro modo su
                        información de identificación personal a terceros.
                    </p>

                    <h3>(2) Información de identificación no personal</h3>
                    <p>
                        Utilizamos la información de identificación no personal
                        recopilada en los Sitios de la manera descrita
                        anteriormente en la Sección A(2). Podemos compartir esta
                        información de identificación no personal con terceros.
                    </p>

                    <h2>
                        D. Recopilación y uso de información de niños menores de
                        13 años
                    </h2>
                    <h3>
                        (1) Recopilación de información de identificación
                        personal recopilada de niños
                    </h3>
                    <p>
                        En la mayoría de los casos, Discovery solo solicitará el
                        nombre y dirección de correo electrónico del niño con el
                        fin de completar una solicitud inmediata del niño. La
                        información que se recopila solo será utilizada para el
                        fin solicitado y se eliminará inmediatamente. Discovery
                        no almacenará ni utilizará de otro modo esa información.
                        Estos son algunos ejemplos de casos en los que Discovery
                        puede eliminar inmediatamente la información del niño,
                        después de completar la solicitud inicial del niño:
                    </p>
                    <ul>
                        <li>
                            Si el niño envía un correo electrónico para realizar
                            una consulta;
                        </li>
                        <li>Si el niño participa en un juego;</li>
                        <li>
                            Si el niño le comparte un juego a un amigo, podemos
                            solicitar su nombre y dirección de correo
                            electrónico y el primer nombre, dirección y correo
                            electrónico del amigo;
                        </li>
                        <li>
                            Si el niño quiere recibir una postal en una ocasión;
                            y
                        </li>
                        <li>
                            Si el niño le envía una postal a un amigo en una
                            ocasión, podemos solicitar su nombre y dirección de
                            correo electrónico y el primer nombre, dirección y
                            correo electrónico del amigo.
                        </li>
                    </ul>

                    <p>
                        Oportunamente, podemos solicitar información de
                        identificación personal limitada de los niños con el fin
                        de ofrecer un servicio, una promoción u otra actividad a
                        los niños. En dicho caso, solicitaremos al niño que
                        proporcione su dirección de correo electrónico, así como
                        la dirección de correo electrónico de sus padres o tutor
                        legal ("padres"). Discovery utilizará dicha dirección de
                        correo electrónico para enviar un correo electrónico a
                        los padres para comunicarle que el menor se comunicó con
                        la empresa. El correo electrónico incluirá detalles
                        sobre cómo los padres pueden (i) proporcionar el
                        consentimiento a Discovery; (ii) prohibir que Discovery
                        vuelva a contactar al niño; o (iii) eliminar la
                        información de identificación personal del niño.
                        Discovery no recopilará más información de la
                        estrictamente necesaria para que el niño participe en la
                        actividad en cuestión. <br />
                        <br />A continuación se presentan algunos ejemplos de
                        casos en los que podemos recopilar el nombre y dirección
                        de correo de los niños en los Sitios y requerir el
                        consentimiento de los padres:
                    </p>
                    <ul>
                        <li>
                            Si el niño quiere participar en un sorteo, concurso
                            u otra promoción; y
                        </li>
                        <li>
                            Si el niño quiere recibir boletines de noticias de
                            manera recurrente.
                        </li>
                    </ul>

                    <h3>
                        (2) El uso de información de identificación personal
                        recopilada de los niños
                    </h3>
                    <p>
                        Cuando recopilamos información de identificación
                        personal de niños, solo utilizamos esa información para
                        el fin para el cual fue recopilada. Por ejemplo, si un
                        niño entra en un sorteo, solicitaremos información de
                        los padres (como se describe en la Sección D(1)) y solo
                        utilizaremos la dirección de correo electrónico del niño
                        para inscribir al niño en el sorteo, para notificar a
                        los padres de la inscripción del niño e identificar y
                        notificar al niño si él o ella es un posible ganador. La
                        información de identificación personal no será utilizada
                        para ningún otro propósito y la información de
                        identificación personal no será utilizada después de
                        finalizada la promoción.
                    </p>

                    <h3>
                        (3) Intercambio de información de identificación
                        personal recopilada de los niños
                    </h3>
                    <p>
                        Con excepción de lo dispuesto en esta Sección, no
                        compartimos información de identificación personal
                        recopilada de los niños con terceros no afiliados.
                        Podemos, sin embargo, compartir información de
                        identificación personal de un niño que hemos recopilado
                        con consentimiento de los padres en las siguientes
                        circunstancias limitadas:
                    </p>
                    <ul>
                        <li>
                            Podemos compartir dicha información con los
                            proveedores de servicios de terceros que ayudan a
                            mantener los Sitios de Discovery y nos proporcionan
                            otros servicios administrativos. Intentamos
                            asegurarnos de que estos terceros no afiliados no
                            puedan utilizar la información de identificación
                            personal para cualquier otro propósito, y estos
                            terceros no afiliados han acordado mantener la
                            confidencialidad, seguridad e integridad de la
                            información de identificación personal.
                        </li>
                        <li>
                            Si se selecciona a un niño como un posible ganador
                            de uno de nuestros concursos o sorteos,
                            notificaremos a los padres del niño a través de la
                            dirección de correo electrónico que el niño
                            presentó. Si el padre consiente, recopilaremos y
                            compartiremos esta información con el fin de cumplir
                            con los términos de la promoción.
                        </li>
                        <li>
                            Por último, podemos revelar información de
                            identificación personal de un niño a terceros si
                            creemos que estamos obligados a hacerlo con el fin
                            de cumplir con la ley (incluyendo órdenes judiciales
                            y citaciones); para cumplir con las peticiones de
                            los organismos de aplicación de la ley o el
                            gobierno; para hacer cumplir nuestro Acuerdo de
                            Visitantes; para proteger nuestros derechos,
                            privacidad, seguridad o propiedad y los derechos,
                            privacidad, seguridad o propiedad de nuestros
                            empleados u otros usuarios de nuestros Sitios; para
                            proteger nuestras operaciones; y para permitirnos
                            procurar las compensaciones disponibles o limitar
                            los daños y perjuicios que podamos sufrir.
                        </li>
                    </ul>

                    <h3>(4) Información de identificación no personal</h3>
                    <p>
                        Recopilamos y almacenamos la información de
                        identificación no personal que se describe en la Sección
                        A(2) de la presente política de privacidad. Sin embargo,
                        no vinculamos esta información a la información de
                        identificación personal cuando proviene de niños.
                    </p>

                    <h3>(5) Nota a los padres y tutores legales</h3>
                    <p>
                        No dude en ponerse en contacto con Discovery, en
                        cualquier momento, con respecto a preguntas o dudas
                        sobre la privacidad, o para solicitar la revisión de la
                        información de identificación personal que hemos
                        recopilado de un niño. Los padres también pueden
                        contactarnos en cualquier momento, para solicitar que
                        borremos la información de identificación personal de un
                        niño o un padre y/o negar el permiso para que se siga
                        recopilando o utilizando la información de un niño.
                        Tomaremos las medidas necesarias para garantizar
                        asegurarnos que cualquier persona que nos contacte con
                        respecto a la información de un niño, sea el padre o
                        tutor del niño.
                        <br />
                        <br />
                        Discovery Communications, LLC
                        <br />
                        c/o Discovery Latin America, LLC
                        <br />
                        6505 Blue Lagoon Drive <br />
                        Miami, FL 33126
                        <br />
                        Teléfono: (786) 273-4700 (Legal)
                        <br />
                        Correo electrónico: legal_dla@discovery.com
                    </p>

                    <h2>E. Transferencia Internacional de Información</h2>
                    <p>
                        Si decide proporcionarnos información de identificación
                        personal, Discovery podrá transferir esa información a
                        sus filiales y subsidiarias o a terceros, en otros
                        territorios, y desde su país o jurisdicción a otros
                        países o jurisdicciones del mundo. Si nos visita desde
                        la Unión Europea, Latinoamérica u otras regiones con
                        leyes que rigen la recopilación y el uso de datos que
                        pueden diferir de las leyes estadounidenses, tenga en
                        cuenta que va a transferir su información de
                        identificación personal a Estados Unidos que no tiene
                        las mismas leyes de protección de datos que la UE, ni
                        Latinoamérica, y al proporcionar su información de
                        identificación personal usted acepta:
                    </p>
                    <ul>
                        <li>
                            el uso de su información de identificación personal
                            para los usos identificados anteriormente de acuerdo
                            con esta política de privacidad; y
                        </li>
                        <li>
                            la transferencia de su información de identificación
                            personal a Estados Unidos como se ha indicado
                            anteriormente.
                        </li>
                    </ul>

                    <h2>F. Opción de exclusión</h2>
                    <p>
                        Podemos utilizar su dirección de correo electrónico para
                        enviarle información sobre los cambios en nuestros
                        productos y servicios, y para enviar avisos y otra
                        información como exige la ley. En general, los usuarios
                        no pueden optar por dejar de recibir estas
                        notificaciones, pero estas serán principalmente de
                        carácter informativo y no promocional. Sin embargo, le
                        ofrecemos la oportunidad de ejercer una opción de
                        exclusión si no desea recibir otros tipos de
                        comunicación de nosotros, como correos electrónicos o
                        actualizaciones con respecto a los nuevos servicios y
                        productos ofrecidos en los Sitios o si no desea que
                        compartamos su información de identificación personal
                        con terceros. La opción de exclusión puede ser ejercida
                        marcando o desmarcando la casilla correspondiente si
                        dicha casilla está disponible en los puntos donde se
                        recopila información de identificación personal o
                        contactándonos. Procesaremos su cancelación de
                        suscripción lo más pronto posible, pero tenga en cuenta
                        que en algunas circunstancias puede recibir algunos
                        mensajes adicionales, hasta que se procese la
                        cancelación de suscripción. También puede optar por no
                        recibir este tipo de mensajes de correo electrónico
                        haciendo clic en el enlace "cancelar suscripción" en el
                        texto del correo electrónico.
                    </p>

                    <h2>
                        G. Foros, salas de chat y demás zonas públicas de
                        publicación
                    </h2>
                    <p>
                        Tenga en cuenta que cualquier información que usted
                        incluya en un mensaje que publique en cualquier sala de
                        chat, foro u otra zona pública de publicación está
                        disponible a cualquier persona con acceso a Internet. Si
                        no quiere que la gente sepa su dirección de correo
                        electrónico, por ejemplo, no la incluya en ningún
                        mensaje que escriba públicamente. LE SOLICITAMOS QUE
                        TENGA MUCHO CUIDADO AL DIVULGAR INFORMACIÓN EN SALAS DE
                        CHAT, FOROS Y DEMÁS ZONAS PÚBLICAS DE PUBLICACIÓN. NO
                        SOMOS RESPONSABLES DEL USO POR PARTE DE TERCEROS DE LA
                        INFORMACIÓN QUE REVELE EN SALAS DE CHAT, FOROS Y DEMÁS
                        ZONAS PÚBLICAS DE PUBLICACIÓN.
                    </p>

                    <h2>H. Sitios Web de Terceros</h2>
                    <p>
                        Esta declaración se aplica únicamente a la información
                        recopilada en los Sitios. Los Sitios pueden contener
                        enlaces a otros sitios web. No somos responsables de las
                        prácticas de privacidad o el contenido de estos otros
                        sitios web.
                    </p>

                    <h2>I. Cesión</h2>
                    <p>
                        En el supuesto de que todo o parte de nuestros activos
                        sean vendidos o adquiridos por un tercero, o en el caso
                        de una fusión, nos concede el derecho de ceder la
                        información de identificación personal y de
                        identificación no personal recopilada a través de los
                        Sitios.
                    </p>

                    <h2>J. Cambios a la política de confidencialidad</h2>
                    <p>
                        Nos reservamos el derecho de cambiar esta política de
                        privacidad oportunamente. Cuando lo hagamos, también
                        modificaremos la fecha de la "última actualización" en
                        la parte inferior de esta política de privacidad. Para
                        los cambios en esta política de privacidad que puedan
                        ser considerablemente menos restrictivos sobre el uso o
                        divulgación de información personal que usted nos ha
                        proporcionado, procuraremos obtener su consentimiento
                        antes de hacerlos efectivos mediante el envío de un
                        aviso a la dirección de correo electrónico principal
                        especificada en su cuenta o publicando un aviso
                        destacado en los Sitios. <br />
                        También notificaremos a los padres si cambiamos el tipo
                        de información que recopilamos de los niños y
                        modificamos considerablemente nuestras prácticas de
                        compartir y usar esta información. No recopilaremos,
                        utilizaremos o compartiremos la información sin
                        consentimiento de los padres.
                    </p>

                    <h2>K. Seguridad</h2>
                    <p>
                        No se puede garantizar que una transmisión de datos a
                        través de Internet sea 100% segura. En consecuencia, no
                        podemos asegurar o garantizar la seguridad de ninguna
                        información que nos transmita y usted entiende que
                        cualquier información que transfiera a Discovery se hace
                        a su propio riesgo.
                        <br />
                        Cuando recibimos su transmisión, realizamos los
                        esfuerzos razonables para garantizar la seguridad en
                        nuestros sistemas. Utilizamos firewalls para proteger su
                        información contra el acceso, revelación, modificación o
                        destrucción no autorizados. Sin embargo, tenga en cuenta
                        que esto no es una garantía de que no se pueda acceder,
                        divulgar, modificar o destruir dicha información por la
                        violación de dichos firewalls y software de seguridad
                        del servidor.
                        <br />
                        Si nos enteramos de una violación de los sistemas de
                        seguridad, intentaremos notificarle electrónicamente
                        para que usted pueda tomar medidas de protección
                        adecuadas. Mediante el uso de estos sitios o mediante el
                        suministro de información personal, acepta que podamos
                        comunicarnos con usted electrónicamente en materia de
                        seguridad, privacidad y cuestiones administrativas
                        relativas al uso de estos sitios. Podemos publicar un
                        aviso en nuestros sitios si se produce una violación de
                        seguridad. También le podemos enviar un correo
                        electrónico a la dirección de correo electrónico que nos
                        ha proporcionado en estas circunstancias. Dependiendo de
                        dónde viva, puede tener un derecho legal de recibir una
                        notificación de una violación de seguridad por escrito.
                    </p>

                    <h2>L. Verificación de la edad</h2>
                    <p>
                        Algunas partes de los Sitios requieren que se
                        proporcione información de identificación personal con
                        el fin de participar. Por ejemplo, si quiere recibir uno
                        de nuestros boletines, debe darnos su dirección de
                        correo electrónico. Algunas partes de los Sitios tendrán
                        un mecanismo de verificación de edad para evitar que los
                        niños se registren. No permitiremos, a sabiendas, que
                        ninguna persona menor de 13 años se registre en ninguno
                        de nuestros Sitios o acceda a los servicios que
                        requieren inscripción, excepto que se establezca
                        explícitamente en el presente documento.
                        <br />
                        Si tomamos conocimiento de que inadvertidamente hemos
                        recibido información de identificación personal de un
                        usuario menor de 13 años, salvo en una situación
                        legalmente permitida, borraremos la información de
                        nuestros registros tan pronto como lo descubramos.
                    </p>

                    <h2>M. Cómo ponerse en contacto con Discovery</h2>
                    <p>
                        Si tiene alguna pregunta sobre esta política de
                        privacidad o nuestras prácticas de privacidad, por favor
                        contáctenos en legal_dla@discovery.com. Toda la
                        información que proporcione en cualquier comunicación
                        escrita también estará incluida en esta política.
                        <br />
                        Información de contacto:
                        <br />
                        6505 Blue Lagoon Drive
                        <br />
                        Miami, Florida 33126
                        <br />
                        Main: (786) 273-4700
                        <br />
                    </p>

                    <h2>N. Resolución de pleitos</h2>
                    <p>
                        En caso de cualquier controversia, reclamación o pleito
                        ("pleito") relacionados con o que surjan de su uso de
                        los Sitios, aparte de los pleitos relacionados con o que
                        involucren la propiedad intelectual de Discovery o los
                        derechos de propiedad intelectual y de propiedad
                        registrada de Discovery, usted y Discovery acuerdan
                        mutuamente el siguiente procedimiento de resolución de
                        pleitos:
                    </p>
                    <ul>
                        <li>
                            1. Las partes primero intentarán de buena fe
                            resolver cualquier pleito mediante negociación
                            informal. El período de negociación informal se
                            iniciará cuando la parte que interpone el pleito
                            envíe una notificación por escrito a la otra parte
                            que describe los hechos y circunstancias del pleito.
                            Si, después de sesenta (60) días a partir de la
                            fecha en que se envía la notificación del pleito,
                            las partes no han podido resolver el pleito,
                            cualquiera de las partes podrá iniciar el arbitraje
                            vinculante. Las partes podrán acordar ampliar el
                            plazo de resolución de pleitos informal de mutuo
                            acuerdo por escrito.
                        </li>
                        <li>
                            2. Si las partes no pueden resolver el pleito a
                            través de negociaciones informales, usted y
                            Discovery aceptan que la competencia exclusiva para
                            el pleito será el arbitraje vinculante ante un
                            árbitro que se acordará mutuamente por ambas partes.
                            Si las partes no se ponen de acuerdo en la selección
                            de un árbitro, cada una seleccionará un árbitro de
                            la lista de árbitros habilitados de JAMS y esos dos
                            árbitros elegirán a la persona que actuará como
                            árbitro de ese pleito. El arbitraje se iniciará en
                            Nueva York, NY, y será administrado por JAMS de
                            conformidad con sus Normas y Procedimientos de
                            Arbitraje Integrales. La sentencia sobre cualquier
                            posible laudo puede ser registrada en cualquier
                            tribunal que tenga competencia. AL USAR LOS SITIOS
                            POR LA PRESENTE RENUNCIA A SU DERECHO A ENTABLAR UN
                            PLEITO EN TRIBUNALES ANTE UN JUEZ O JURADO. A menos
                            que el árbitro llegue a la conclusión de que el
                            arbitraje era frívolo o que se presentó con un
                            propósito indebido, Discovery pagará todos los
                            honorarios y gastos del árbitro, JAMS y
                            presentaciones.{' '}
                        </li>
                        <li>
                            3. TODOS LOS PLEITOS SERÁN RESUELTOS DE FORMA
                            INDIVIDUAL. Ninguna de las partes tendrá derecho a
                            que se atienda un pleito como una demanda colectiva
                            y ningún arbitraje o procedimiento se puede combinar
                            con otro sin el consentimiento previo por escrito de
                            todas las partes en el procedimiento.
                        </li>
                    </ul>

                    <h2>O. Legislación aplicable</h2>
                    <p>
                        Esta política de privacidad se ha hecho y se
                        interpretará de conformidad con las leyes del Estado de
                        Maryland, sin dar curso a ningún conflicto de principios
                        legales.
                        <br />
                        <br />
                        Las partes reconocen que esta política evidencia una
                        transacción que involucra el comercio interestatal. No
                        obstante lo dispuesto en el párrafo anterior con
                        respecto al derecho sustantivo aplicable, cualquier
                        arbitraje realizado de conformidad con los términos de
                        esta política se regirá por la Ley Federal de Arbitraje
                        (9 USC §§ 1-16).
                    </p>

                    <h2>P. Foro aplicable</h2>
                    <p>
                        Mediante el uso de los Sitios de Discovery, acepta que
                        la competencia exclusiva para cualquier pleito que no
                        esté sujeto a la disposición de arbitraje que se
                        describió anteriormente la tendrán los tribunales
                        estatales y federales ubicados en Maryland.
                    </p>

                    <h2>Sus derechos de privacidad en California</h2>
                    <p>
                        Discovery no admite la configuración "Do Not Track" del
                        navegador y no participa actualmente en ningún sistema
                        "Do Not Track" que nos permitiría responder a otros de
                        sus mecanismos o señales con respecto a la recopilación
                        de su información de identificación personal o
                        información de identificación no personal.
                        <br />
                        <br />
                        A partir del 1º de enero de 2005, el artículo 1798.83
                        del Código Civil de California permite a nuestros
                        visitantes que son residentes de California solicitar
                        cierta información relacionada con la divulgación de
                        Discovery de información personal a terceros con fines
                        de marketing directo. Para realizar dicha solicitud,
                        póngase en contacto con nosotros:
                        <br />
                        <br />
                        Discovery Communications, LLC
                        <br />
                        1 Discovery Place
                        <br />
                        Silver Spring, MD 20910
                        <br />
                        Teléfono: (240) 662-2000 (Legal) <br />
                        Correo electrónico: legal_dla@discovery.com
                        <br />
                        <br />
                        Última actualización: 11 de enero de 2021.
                    </p>
                </div>
            </Container>
        );
    } else if (location.pathname.indexOf('termos-de-uso') > -1) {
        return (
            <Container>
                <div class="cuerpo">
                    <h1>TERMOS DE USO / ACORDO DE UTILIZAÇÃO</h1>

                    <p>
                        Bem-vindo ao Discovery K!ds Plus um dos sites e
                        aplicativos voltados à informação, educação e
                        entretenimento, disponibilizados para você pela
                        Discovery Communications, LLC, suas subsidiárias e
                        afiliadas, (“Discovery”). Por favor, leia o presente
                        Acordo de Utilização; ao utilizar este site/aplicativo,
                        você aceita os termos deste acordo.
                    </p>

                    <p>
                        Este Acordo de Utilização aplica-se a todos os sites e
                        aplicativos onde ele é publicado. Esses
                        sites/aplicativos serão doravante coletivamente
                        referidos neste Acordo de Utilização como “Site”. Termos
                        e condições adicionais podem ser aplicados a alguns
                        serviços oferecidos pelo Site. Tais termos e condições
                        podem ser encontrados no local onde o serviço relevante
                        é oferecido. Por exemplo: políticas regendo concursos e
                        promoções promovidos pela Discovery podem ser
                        encontrados nas páginas de cada concurso ou promoção.
                    </p>

                    <p>
                        A internet é uma mídia em evolução; a Discovery pode
                        mudar os termos deste Acordo de Utilização de tempos em
                        tempos. Ao continuar utilizando o Site após a publicação
                        das referidas mudanças, você está ciente quanto aos
                        termos e condições deste Acordo de Utilização, conforme
                        modificado. A Discovery pode restringir o acesso,
                        suspender ou descontinuar o Site, assim como parte(s)
                        dele, a qualquer momento. A Discovery respeita a
                        privacidade de seus usuários. Por favor, reserve alguns
                        minutos para ler nossa Política de Privacidade.
                    </p>

                    <p>
                        Se você discordar de qualquer material que encontrar no
                        Site, recomendamos que nos comunique. Nós também o
                        convidamos a voltar sua atenção a qualquer material que
                        lhe pareça factualmente incorreto, contatando a
                        Discovery Networks Brasil, Rua Funchal, 418, 5º andar,
                        São Paulo, SP, CEP 04551-060 – Departamento Jurídico.
                    </p>

                    <p>
                        Os materiais constantes do Site têm propósito
                        exclusivamente informativo e de entretenimento. Apesar
                        de nossos esforços em fornecer informações úteis e
                        corretas, eventualmente, erros podem surgir. Antes de
                        agir baseando-se em informações contidas no Site, você
                        deve confirmar quaisquer dados que sejam importantes
                        para a sua decisão. A Discovery e suas fontes de
                        informação não se responsabilizam pela confiabilidade,
                        exatidão, atualidade, utilidade e completude da
                        informação contida no Site. A Discovery não é
                        responsável por, e não pode garantir o desempenho de
                        eventuais bens e serviços fornecidos por nossos
                        anunciantes ou por outros sites acessados através de
                        links constantes do Site. Um link para outro site não
                        constitui endosso deste site (nem de qualquer produto,
                        serviço ou qualquer outro material oferecido por
                        referido site) pela Discovery ou por seus licenciantes.
                    </p>

                    <h2>
                        NOTIFICAÇÃO E PROCEDIMENTO PARA ALEGAR VIOLAÇÃO DE
                        DIREITOS AUTORAIS (COPYRIGHT)
                    </h2>

                    <p>
                        A Discovery busca sempre respeitar a liberdade de
                        expressão dos usuários de seu Site, desde que esta não
                        conflite com os direitos autorais de terceiros. Dessa
                        forma, nós nos reservamos o direito (mas não assumimos a
                        obrigação) de remover todo e qualquer conteúdo que, a
                        nosso exclusivo critério, acreditamos violar direitos
                        autorais de terceiros.
                    </p>

                    <p>
                        Caso você considere que algum conteúdo disponibilizado
                        nos Sites Discovery viola qualquer direito autoral de
                        sua titularidade, poderá enviar notificação para
                        Discovery Networks Brasil, Rua Funchal, 418, 5º andar,
                        São Paulo, SP, CEP 04551-060 – Departamento Jurídico,
                        e/ou para: Leah Montesano, Legal Affairs, Discovery
                        Communications, LLC., One Discovery Place, Silver
                        Spring, MD 20910, telefone 1 240.662.0000, fac-símile 1
                        240.662.1903, e-Mail dmca_notices@discovery.com.
                    </p>

                    <p>
                        Para ser válida, a notificação deve ser feita por
                        escrito e deve conter as seguintes informações:
                    </p>

                    <ol>
                        <li>
                            Assinatura física ou eletrônica de uma pessoa
                            autorizada para agir em nome do titular do direito
                            autoral supostamente violado;
                        </li>
                        <li>
                            Identificação da obra protegida, cujos direitos
                            tenham sido supostamente violados; ou, no caso de
                            várias obras protegidas estarem descritas em uma
                            única notificação, apresentar uma lista das
                            referidas obras;
                        </li>
                        <li>
                            Identificação do material que supostamente viole
                            esses direitos de propriedade intelectual, com o
                            objetivo de removê-lo ou de desativar o acesso ao
                            mesmo, além de dados razoavelmente suficientes para
                            permitir-nos localizar referido material, como a
                            indicação da URL (endereço eletrônico desse
                            conteúdo, como www.exemplo.com/material.html);
                        </li>
                        <li>
                            Informação razoavelmente suficiente que nos permita
                            entrar em contato com a parte reclamante, como
                            endereço, número de telefone e, se disponível, um
                            endereço de correio eletrônico;
                        </li>
                        <li>
                            Declaração de que a parte reclamante acredita de boa
                            fé que o uso do material da maneira reclamada não
                            foi autorizado pelo titular dos direitos autorais,
                            por seu representante ou pela lei; e
                        </li>
                        <li>
                            Declaração de que as informações na notificação
                            estão corretas e de que a parte reclamante está
                            autorizada a agir em nome do titular dos direitos
                            exclusivos que tenham sido supostamente violados.
                        </li>
                    </ol>

                    <p>
                        Podemos notificar os nossos usuários acusados de
                        infração a direitos autorais de terceiros por meio de
                        aviso geral publicado em nosso Site, mensagem por
                        correio eletrônico aos usuários com endereços
                        eletrônicos em nosso cadastro, ou comunicação por
                        escrito enviada por carta registrada para o endereço
                        físico do usuário que conste em nosso cadastro. Se você
                        receber esse tipo de aviso, pode fornecer uma
                        contranotificação por escrito destinada ao representante
                        designado (conforme descrito acima), que, para ser
                        válida, deve incluir o seguinte:
                    </p>

                    <ol>
                        <li>Sua assinatura física ou eletrônica;</li>
                        <li>
                            Identificação do material que foi removido ou cujo
                            acesso foi desativado, e o local no qual o material
                            aparecia antes de ser removido ou de ter seu acesso
                            desativado;
                        </li>
                        <li>
                            Declaração de que você acredita, de boa fé, que o
                            material foi removido ou desativado em consequência
                            de engano ou de má identificação;
                        </li>
                        <li>
                            Justificativa que explique a razão pela qual você
                            acredita que o material foi removido injustamente, e
                            no caso de você possuir autorização para utilizar
                            material protegido por direito autoral de terceiro,
                            incluir referida autorização; e
                        </li>
                        <li>
                            Seu nome, e-mail, endereço físico e número de
                            telefone, além de uma declaração reconhecendo (i) a
                            jurisdição do Foro Distrital Federal da comarca na
                            qual o seu endereço físico está localizado ou, se o
                            seu endereço físico for fora dos Estados Unidos da
                            América, da comarca de sua residência, e (ii) que
                            aceitará a notificação de eventual processo de parte
                            da pessoa que efetuou a notificação por suposta
                            violação ou de parte de seu representante.
                        </li>
                    </ol>

                    <h2>VÍDEO GERADO POR USUÁRIO</h2>

                    <p>
                        Ao publicar vídeos nos Sites Discovery, você concorda
                        com os seguintes termos e condições:
                    </p>

                    <p>
                        VOCÊ, ENQUANTO TITULAR DOS DIREITOS DE PROPRIEDADE
                        INTELECTUAL DO VÍDEO ENVIADO POR VOCÊ À DISCOVERY,
                        CONCEDE À DISCOVERY COMMUNICATIONS, LLC., SUAS MATRIZES,
                        ASSOCIADAS, AFILIADAS, SUBSIDIÁRIAS, LICENCIADAS,
                        EMPREGADOS, PRODUTORES, SUCESSORES E CESSIONÁRIOS DE
                        TODOS OS SUPRACITADOS, BEM COMO A SEUS DISTRIBUIDORES DE
                        PROGRAMAÇÃO E CONTEÚDO, E SUAS RESPECTIVAS MATRIZES,
                        ASSOCIADAS, AFILIADAS, SUBSIDIÁRIAS, LICENCIADAS,
                        EMPREGADOS, PRODUTORES, SUCESSORES E CESSIONÁRIOS DE
                        TODOS OS SUPRACITADOS (COLETIVAMENTE, AS “EMPRESAS
                        DISCOVERY”) UMA LICENÇA NÃO EXCLUSIVA, SEM LIMITE DE
                        TEMPO E LOCAL, ISENTA DE ROYALTIES, PARA FAZER USO E
                        DISTRIBUIR O VÍDEO ENVIADO POR VOCÊ, CONFORME AQUI
                        DESCRITO, ASSIM COMO SEU NOME, VOZ, APARÊNCIA E IMAGEM
                        (SE HOUVER), E TODAS AS INFORMAÇÕES DE IDENTIFICAÇÃO
                        PESSOAL QUE VOCÊ FORNECER OU QUE TENHAM LIGAÇÃO COM O
                        VÍDEO (COLETIVAMENTE, “VÍDEO PUBLICADO”), CONFORME
                        DESCRITO ABAIXO. VOCÊ TEM CONHECIMENTO E CONCORDA QUE
                        NÃO TERÁ DIREITO A PARTICIPAR DE QUALQUER BENEFÍCIO OU
                        VANTAGEM QUE AS EMPRESAS DISCOVERY POSSAM AUFERIR OU
                        GERAR POR MEIO DO USO DO SEU VÍDEO PUBLICADO.
                    </p>

                    <p>
                        Direitos de Uso pelas Empresas Discovery do seu Vídeo
                        Publicado. Você concede às Empresas Discovery o direito
                        não exclusivo de editar de qualquer maneira, de usar,
                        distribuir e licenciar a terceiros o uso e a
                        distribuição de seu Vídeo Publicado, ou de qualquer
                        trecho do Vídeo Publicado, seja de reprodução ou de
                        versão dele, nos websites, bem como em produtos e/ou
                        serviços das Empresas Discovery, em toda e qualquer
                        mídia, já conhecida ou que venha a ser inventada,
                        inclusive, sem limitação, televisão, home vídeo/DVD,
                        vídeo sob demanda, mídias digitais, internet e serviços
                        de telefonia móvel, por ilimitado número de vezes, sem
                        limite de tempo, em todo o mundo, com ou sem cobrança ou
                        custo para usuários finais ou terceiros. Você também
                        concede às Empresas Discovery o direito de usar,
                        distribuir e de licenciar a terceiros o direito de uso e
                        distribuição de seu Vídeo Publicado para a promoção de
                        websites, produtos e/ou serviços de terceiros, da mesma
                        maneira que permite o uso e distribuição de seu Vídeo
                        Publicado de acordo com este documento.
                    </p>

                    <h2>
                        LIBERAÇÃO DE SEU VÍDEO PUBLICADO PARA USO PELAS EMPRESAS
                        DISCOVERY
                    </h2>

                    <p>
                        Você declara e garante que seu Vídeo Publicado é sua
                        obra original e que você obteve todos e quaisquer
                        direitos, permissões de publicação e autorizações
                        necessárias para uso e distribuição pelas Empresas
                        Discovery do seu Vídeo Publicado de acordo com este
                        documento, inclusive, sem limitação, aqueles
                        relacionados à liberação de direitos de personalidade e
                        direitos autorais de qualquer pessoa, locação, música,
                        apresentação de dança, vídeo, fotografias e/ou arte
                        gráfica presentes em seu Vídeo Publicado, inclusive, se
                        aplicável, autorizações administrativas ou judiciais
                        para produção do Vídeo Publicado (coletivamente, os
                        “Elementos”). Você declara e garante que conhece a
                        legislação brasileira sobre direitos autorais, assim
                        como o Estatuto da Criança e do Adolescente, o Marco
                        Civil da Internet, bem como todas as demais legislações
                        aplicáveis, e de acordo com o seu melhor conhecimento,
                        não haverá necessidade de novas permissões ou taxas para
                        que as Empresas Discovery possam utilizar e/ou
                        distribuir o seu Vídeo Publicado ou quaisquer Elementos
                        nesse sentido. Você também declara e garante que
                        quaisquer declarações emitidas por você ou outrem no
                        Vídeo Publicado são verdadeiras e que nem elas, nem
                        qualquer outro Elemento do seu Vídeo Publicado, violarão
                        qualquer lei ou regulamentação, nem violarão ou
                        infringirão direitos de terceiros.
                    </p>

                    <h2>RENÚNCIA DO DIREITO DE APROVAÇÃO </h2>

                    <p>
                        Você, por meio deste, renuncia a qualquer direito de
                        inspeção ou de aprovação de seu Vídeo Publicado, da
                        maneira que for usado e distribuído pelas Empresas
                        Discovery, inclusive, sem limitação, qualquer aprovação
                        de sua aparição e/ou do uso do seu nome, ou de qualquer
                        outro uso que se faça do Vídeo Publicado.
                    </p>

                    <h2>AUTORIZAÇÃO E RENÚNCIA; INDENIZAÇÃO</h2>

                    <p>
                        Você tem conhecimento e reconhece que as Empresas
                        Discovery confiarão nos termos e condições supracitados,
                        que potencialmente lhe acarretarão custos substanciais,
                        e você, por meio deste, abre mão do direito de fazer
                        reivindicações de qualquer natureza contra qualquer
                        parte envolvida no exercício dos direitos e das
                        permissões concedidas neste documento. Você concorda em
                        indenizar, defender e isentar as Empresas Discovery de
                        toda e qualquer reivindicação proveniente do uso e
                        distribuição pelas empresas Discovery do seu Vídeo
                        Publicado, conforme autorizado neste documento.
                    </p>

                    <h2>CONTEÚDO DOS VÍDEOS PUBLICADOS</h2>

                    <p>
                        Você concorda em não incluir nos Vídeos Publicados
                        material calunioso, difamatório, abusivo, obsceno,
                        pornográfico, ameaçador e/ou ilegal, nem qualquer
                        material que infrinja a possibilidade de outros
                        utilizarem o Site, ou que viole os direitos de outrem.
                        Você não pode enviar Vídeos Publicados anonimamente ou
                        sob o nome de outra pessoa.
                    </p>

                    <h2>SALAS DE BATE-PAPO, FÓRUNS E BLOGS</h2>

                    <p>
                        A Discovery deseja encorajar um intercâmbio aberto de
                        informações e ideias por meio do Site, mas nós não
                        podemos e não revisamos todas as postagens feitas em
                        salas de bate-papo, fóruns, blogs ou outras áreas de
                        postagens públicas do Site. Essas áreas podem incluir
                        conteúdos, informações e opiniões de uma variedade de
                        indivíduos e organizações sem qualquer relação com a
                        Discovery. Nós não endossamos nem garantimos a exatidão
                        de quaisquer postagens, independentemente da postagem
                        ter vindo de um usuário, de um convidado “especialista”,
                        de uma celebridade, ou de um membro de nossa equipe ou
                        apresentador de nossos canais. Nada substitui o
                        ceticismo saudável e o seu próprio bom-senso.
                    </p>

                    <p>
                        A responsabilidade pelo que é postado nas salas de
                        bate-papo, fóruns, blogs e outras áreas de postagens
                        públicas no Site é de cada usuário – você é o único
                        responsável pelo material que postar. A Discovery não
                        controla as mensagens, a informação ou qualquer outro
                        conteúdo que você ou outros forneçam através do Site.
                        Você só está autorizado a utilizar o Site com propósitos
                        lícitos. Ao utilizar o Site, você concorda em não postar
                        nem transmitir material calunioso, difamatório, abusivo,
                        obsceno, pornográfico, ameaçador ou ilegal, nem qualquer
                        outro material que infrinja a possibilidade de outros
                        utilizarem o Site, ou que viole os direitos de outrem.
                        Você não pode postar nem transmitir mensagens
                        anonimamente ou sob o nome de outra pessoa. Você não
                        pode permitir que qualquer pessoa acesse, utilizando sua
                        conta, quaisquer serviços do Site que requeiram
                        cadastramento. Você não pode postar uma mesma mensagem
                        em mais de 5 (cinco) áreas do Site, ou publicar qualquer
                        mensagem que, a critério exclusivo da Discovery, viole
                        este Acordo de Utilização.
                    </p>

                    <p>
                        Embora a Discovery não possa monitorar todas as
                        postagens em salas de bate-papo, fóruns, blogs, e outras
                        áreas de postagens públicas, nós nos reservamos o
                        direito (mas não assumimos a obrigação) de monitorar o
                        conteúdo do Site para verificar o cumprimento deste
                        Acordo de Utilização, assim como de qualquer outro
                        regulamento específico que a Discovery venha a
                        estabelecer. A Discovery tem o direito, a seu exclusivo
                        critério e independentemente de qualquer justificativa,
                        de apagar, mover ou editar quaisquer postagens, assim
                        como de abster-se de publicar qualquer material,
                        incluindo, sem limitação, qualquer Vídeo Publicado, que
                        considerarmos, a nosso exclusivo critério, inaceitável
                        ou inapropriado, seja por motivo legal ou qualquer
                        outro.
                    </p>

                    <p>
                        Não obstante o direito acima, os usuários são inteira e
                        exclusivamente responsáveis pelo conteúdo de suas
                        mensagens e de seus Vídeos Publicados. Você reconhece e
                        aceita que nem a Discovery nem seus afiliados assumirão
                        ou terão qualquer responsabilidade por qualquer ação ou
                        omissão da Discovery em relação a alguma conduta sua que
                        tenha sido praticada dentro do Site ou por comunicações
                        ou publicações suas no Site. A Discovery também se
                        reserva o direito de revelar toda informação que
                        considere necessária para dar cumprimento a uma lei,
                        regulamento ou pedido do governo, ou ainda de abster-se
                        de publicar qualquer material ou parte dele.
                    </p>

                    <p>
                        A Discovery exige que você use o Site de forma lícita.
                        Desta maneira, o Site não poderá ser utilizado para
                        violar os direitos autorais, marcas registradas ou
                        qualquer outro direito de propriedade intelectual de
                        qualquer pessoa. Ademais, o Site não poderá ser
                        utilizado para cometer infrações aos direitos da
                        personalidade e quaisquer outros direitos de terceiros.
                    </p>

                    <p>
                        Ao publicar material no Site (incluindo, mas não se
                        limitando a fotografias e vídeos), você declara e
                        garante que é titular do material, que tem direito de
                        publicar o referido material, e/ou que está efetuando a
                        publicação com o consentimento expresso de seu titular,
                        e que nenhuma outra pessoa tem direito, interesse, ou
                        reclamação quanto ao material que você vier a publicar.
                        Você também garante que os direitos morais sobre os
                        materiais que publicar por nosso intermédio serão
                        respeitados. Você concede à Discovery uma licença não
                        exclusiva, sem limite de tempo e local, isenta de
                        royalties, para fazer uso e distribuir todo material que
                        publicar. Publicar material que é de propriedade de
                        outrem, sem o prévio consentimento de seu titular, não é
                        apenas uma violação ao Acordo de Utilização, mas também
                        estará sujeito a responsabilidades legais por infração
                        de direitos autorais, propriedade industrial, e/ou
                        outros direitos de propriedade intelectual.
                    </p>

                    <h2>USO DOS MATERIAIS</h2>

                    <p>
                        Você entende que ao publicar material no Site, em nossas
                        salas de bate-papo, fóruns, blogs e outras áreas de
                        postagens públicas, você concede à Discovery ou a
                        qualquer autorizado da Discovery, uma licença isenta de
                        royalties, sem limite de tempo, irrevogável, ilimitada e
                        válida em todo o mundo, para expor, utilizar, copiar,
                        editar, modificar, transmitir, vender, explorar, criar
                        obras derivadas, distribuir ou publicar tal material, em
                        sua totalidade ou apenas parte dele, em qualquer forma e
                        através de qualquer meio conhecido ou que venha a ser
                        criado futuramente, e para qualquer fim. Adicionalmente,
                        em relação ao exercício destes direitos, você autoriza a
                        Discovery ou qualquer de suas autorizadas, a
                        identificá-lo como autor de qualquer material por você
                        publicado, por meio de seu nome, endereço eletrônico
                        e/ou qualquer outro meio que a Discovery considere
                        apropriado para tanto.
                    </p>

                    <p>
                        Os materiais disponíveis por meio do Site são
                        propriedade da Discovery e de suas licenciantes, e são
                        protegidos pelas leis de direitos autorais, propriedade
                        industrial e outros direitos de propriedade intelectual.
                        Você tem liberdade para exibir e imprimir, para seu
                        próprio uso pessoal e não comercial, as informações que
                        receber através do Site. Mas você não pode reproduzir de
                        outra forma qualquer um desses materiais, sem o
                        consentimento prévio e por escrito de seu titular. Você
                        não pode distribuir cópias dos materiais encontrados no
                        Site de qualquer maneira (inclusive e-mail e outras
                        mídias eletrônicas), sem a permissão prévia e por
                        escrito do titular. É claro, você tem liberdade para
                        encorajar outros a acessarem por conta própria
                        informações no Site, e de contar a eles como as
                        encontrou.
                    </p>

                    <h2>LINKS</h2>

                    <p>
                        Nós aceitamos, de bom grado, outros links para o Site.
                        De uma forma geral, você tem liberdade de estabelecer um
                        link de hipertexto em outros sites para o Site, desde
                        que o link não afirme nem sugira qualquer patrocínio ou
                        endosso de referido site pelo Site ou pela Discovery. No
                        entanto, você deve checar o aviso de direitos autorais
                        na página onde deseja fazer o link, para garantir que os
                        fornecedores de conteúdo não tenham políticas próprias a
                        respeito de direcionar links.
                    </p>

                    <h2>ANÚNCIOS E DOAÇÕES</h2>

                    <p>
                        Você concorda em não usar os Sites Discovery para
                        anunciar, ou para solicitar a alguém que compre ou venda
                        produtos ou serviços, nem para solicitar a alguém que
                        faça doações de qualquer tipo, sem a nossa expressa
                        aprovação por escrito.
                    </p>

                    <h2>NÃO AO LIXO ELETRÔNICO</h2>

                    <p>
                        Ocasionalmente, os usuários postam seus endereços de
                        e-mail nas salas de bate-papo, fóruns, blogs e outras
                        áreas de postagens públicas. Você não pode reunir esses
                        endereços de e-mail com propósitos comerciais ou
                        ilegais, tais como o envio de e-mails ou mensagens
                        instantâneas não desejadas.
                    </p>

                    <h2>NÃO REPRODUZIR</h2>

                    <p>
                        Sem permissão prévia por escrito por parte da Discovery,
                        você não pode reproduzir, ou fazer com que um site
                        considerado um terceiro apresente ou endosse quaisquer
                        conteúdos do Site, ou ainda incorporar qualquer direito
                        de propriedade intelectual do Site, da Discovery ou de
                        qualquer um dos seus licenciantes em outro website ou
                        serviço.
                    </p>

                    <h2>MARCAS REGISTRADAS</h2>

                    <p>
                        Não queremos que alguém se confunda sobre quais
                        materiais e serviços são fornecidos pela Discovery e
                        quais não são. Você não pode usar qualquer marca
                        registrada ou marca de serviços que apareçam no Site sem
                        o consentimento prévio por escrito do titular da marca.
                    </p>

                    <h2>AVISO DE GARANTIAS E RESPONSABILIDADES</h2>

                    <p>
                        Nós trabalhamos com afinco para tornar o Site
                        interessante e agradável, mas não podemos garantir que
                        nossos usuários sempre irão encontrar tudo de acordo com
                        o seu gosto. Por favor, leia este aviso atentamente
                        antes de usar os Site.
                    </p>

                    <p>
                        VOCÊ CONCORDA QUE O SEU USO DO SITE É POR SUA CONTA E
                        RISCO. DEVIDO AO NÚMERO DE POSSÍVEIS FONTES DE
                        INFORMAÇÕES DISPONÍVEIS NO SITE, E AOS RISCOS INERENTES
                        E ÀS INCERTEZAS DA DISTRIBUIÇÃO ELETRÔNICA, PODEM
                        OCORRER ATRASOS, OMISSÕES, INCORREÇÕES, OU OUTROS
                        PROBLEMAS COM AS REFERIDAS INFORMAÇÕES. SE VOCÊ CONFIAR
                        NO SITE OU EM QUALQUER MATERIAL DISPONÍVEL NO SITE, O
                        FARÁ POR SUA CONTA E RISCO. VOCÊ RECONHECE QUE É O ÚNICO
                        RESPONSÁVEL POR QUALQUER DANO AO SEU COMPUTADOR OU PELA
                        PERDA DE DADOS QUE RESULTEM DE QUAISQUER MATERIAIS OU
                        DADOS BAIXADOS DE, OU FORNECIDOS DE OUTRA MANEIRA NO
                        SITE.
                    </p>

                    <p>
                        O SITE É FORNECIDO A VOCÊ COMO É, COM TODAS AS FALHAS, E
                        DE ACORDO COM A DISPONIBILIDADE. O SITE, A DISCOVERY
                        COMMUNICATIONS, LLC., SUAS AFILIADAS, REPRESENTANTES E
                        LICENCIANTES NÃO PODEM E NÃO GARANTEM A CORREÇÃO,
                        INTEGRIDADE, ATUALIDADE, NÃO-INFRAÇÃO, POTENCIAL
                        COMERCIAL OU CONVENIÊNCIA PARA UM PROPÓSITO EM
                        PARTICULAR DA INFORMAÇÃO DISPONIBILIZADA POR MEIO DO
                        SITE, NEM GARANTEM QUE O SITE ESTARÁ ISENTO DE ERROS OU
                        CONTINUAMENTE DISPONÍVEL, OU QUE O SITE ESTARÁ LIVRE DE
                        VÍRUS E DE OUTROS COMPONENTES PREJUDICIAIS.
                    </p>

                    <p>
                        NA MEDIDA APLICÁVEL EM SUA JURISDIÇÃO, SOB NENHUMA
                        CIRCUNSTÂNCIA, O SITE, A DISCOVERY COMMUNICATIONS, LLC.,
                        OU SUAS AFILIADAS, REPRESENTANTES E LICENCIANTES SERÃO
                        RESPONSÁVEIS POR QUAISQUER DANOS CAUSADOS A VOCÊ OU A
                        QUALQUER OUTRA PESSOA, DECORRENTES DO USO DO SITE,
                        INCLUSIVE, SEM LIMITAÇÃO, RESPONSABILIDADE POR DANOS
                        EMERGENTES, CONSEQUENTES, ESPECIAIS, INCIDENTAIS,
                        INDIRETOS OU SIMILARES, LUCROS CESSANTES, DANOS DIRETOS
                        E INDIRETOS, E AINDA, PERDA DE OPORTUNIDADE, MESMO QUE
                        NÓS SEJAMOS AVISADOS COM ANTECEDÊNCIA DA POSSIBILIDADE
                        DOS REFERIDOS DANOS. VOCÊ CONCORDA QUE A
                        RESPONSABILIDADE DO SITE, DA DISCOVERY COMMUNICATIONS,
                        LLC., E/OU DE SUAS AFILIADAS, REPRESENTANTES E
                        LICENCIANTES, SE HOUVER, DECORRENTE DE QUALQUER PEDIDO
                        JUDICIAL DE ALGUMA FORMA RELACIONADA AO SITE, NÃO
                        EXCEDERÁ A QUANTIA, SE HOUVER, QUE VOCÊ TIVER PAGO À
                        DISCOVERY COMMUNICATIONS, LLC., PELO USO DO SITE.
                    </p>

                    <h2>DIVERSOS</h2>

                    <p>
                        A equipe da Discovery trabalha com afinco para que as
                        informações postadas no Site sejam tanto adequadas
                        quanto corretas. Mas as notícias mudam com o tempo, e
                        reportagens que eram corretas quando foram postadas
                        podem tornar-se rapidamente notícias ultrapassadas.
                        Embora possamos postar atualização de reportagens e
                        continuar a fornecer acesso às reportagens originais,
                        como em arquivos de matérias, por exemplo, nós não
                        alteramos reportagens originais para refletir novos
                        progressos. Se estiver procurando por informações mais
                        recentes sobre um determinado assunto, e não o histórico
                        de como a matéria foi divulgada, certifique-se de que
                        não está pesquisando uma reportagem ultrapassada.
                    </p>

                    <p>
                        Para ter acesso a determinados serviços do Site, você
                        precisa reservar um tempo para se cadastrar no Site.
                        Como em qualquer outro processo de cadastramento, você
                        pode precisar escolher um e-mail, nome de usuário e uma
                        senha, entre outras informações necessárias para
                        cadastramento e autenticação de informações. Você
                        concorda que as informações fornecidas durante o
                        processo de cadastramento estarão corretas e completas,
                        e que você não se registrará, nem tentará entrar no Site
                        sob o nome de outra pessoa. A Discovery se reserva o
                        direito de rejeitar ou eliminar qualquer nome de
                        usuário, e-mail ou senha que, a seu exclusivo critério,
                        julgue ofensivos. Você será responsável por preservar a
                        confidencialidade de sua senha e notificará a Discovery
                        caso tome conhecimento de algum uso suspeito de sua
                        conta sem autorização. Você precisa ter pelo menos 18
                        anos de idade para se cadastrar no Site. Por favor,
                        informe à Discovery se houver modificações nas
                        informações que você tiver fornecido por ocasião do seu
                        cadastramento inicial, inclusive qualquer mudança de
                        endereço, e-mail ou nome, entrando em contato com os
                        nossos representantes através do email
                        protecaodados@discovery.com.
                    </p>

                    <p>
                        Você concorda em indenizar, defender e proteger a
                        Discovery Communications LLC., suas afiliadas, seus
                        oficiais, diretores, funcionários, representantes,
                        licenciantes e fornecedores, de e contra toda e qualquer
                        perda, despesa, dano e custo (inclusive honorários
                        razoáveis de advogados) resultantes de quaisquer
                        violações a este Acordo de Utilização ou de qualquer
                        atividade relacionada à sua conta (inclusive conduta
                        negligente ou ilícita), de sua parte ou de qualquer
                        outra pessoa que acesse o Site utilizando a sua conta.
                    </p>

                    <p>
                        Este Acordo de Utilização possui eficácia e validade
                        jurídica, e será interpretado em conformidade com a
                        legislação brasileira. Ao usar o Site, você concorda que
                        ficam eleitos os foros estaduais e federais localizados
                        no estado de São Paulo, Brasil, como jurisdição
                        exclusiva para dirimir todas as disputas relativa a este
                        Acordo de Utilização.
                    </p>

                    <p>
                        Na eventualidade de qualquer parte deste Acordo de
                        Utilização ser considerada inválida ou inexequível por
                        qualquer motivo, a referida invalidade ou
                        não-exequibilidade de qualquer parte deste Acordo de
                        Utilização não afetará a validade ou exequibilidade de
                        qualquer outra parte deste Acordo de Utilização, que
                        será celebrado como se a parte inválida ou inexequível
                        não fizesse parte do Acordo de Utilização.
                    </p>

                    <h2>USO DE INFORMAÇÕES DE SAÚDE NO SITE</h2>

                    <p>
                        As informações relacionadas a saúde e bem-estar que
                        aparecem no Site são apresentadas apenas em formato
                        resumido, com a intenção de fornecer conhecimentos
                        gerais em assuntos de saúde. As informações não devem
                        ser utilizadas como substituto de uma consulta com um
                        médico ou outro profissional da saúde. O Site não
                        aconselha o autodiagnóstico de problemas médicos ou de
                        saúde, e o Site também não promove nem recomenda
                        qualquer forma de tratamento médico ou alternativo. As
                        pessoas que utilizam as informações acessadas no Sites
                        devem também procurar fontes confiáveis e competentes de
                        informação, inclusive o seu médico e/ou outro
                        profissional de saúde. Informações obtidas por meio do
                        uso do Site não são completas e não cobrem todas as
                        doenças, enfermidades, problemas físicos nem seus
                        respectivos tratamentos. Se você tiver dúvidas relativas
                        à área da saúde, por favor consulte seu médico e/ou
                        outro profissional da saúde. Você nunca deve
                        desconsiderar atendimento médico – ou adiá-lo – em
                        decorrência de algum conteúdo que tiver lido no Site.
                        Você deve sempre procurar atendimento médico imediato
                        para qualquer problema de saúde específico e deve
                        consultar um médico antes de iniciar uma nova dieta
                        alimentar.
                    </p>

                    <h2>CONTEÚDOS DA ASSOCIATED PRESS</h2>

                    <p>
                        O Site inclui certos conteúdos de titularidade da
                        Associated Press. Sem limitar os princípios de qualquer
                        cláusula precedente deste Acordo de Utilização, você
                        especificamente tem conhecimento e concorda que (a)
                        textos, fotos, arte gráfica, áudio e/ou vídeos da
                        Associated Press não devem ser publicados, veiculados,
                        reescritos para veiculação ou publicação ou
                        redistribuídos direta ou indiretamente em qualquer
                        mídia; (b) nenhum material da Associated Press, nem uma
                        parcela destes, podem ser armazenados em computador,
                        exceto para uso pessoal e não-comercial; (c) a
                        Associated Press não será responsabilizada por quaisquer
                        atrasos, incorreções, erros ou omissões destes ou pela
                        transmissão e envio de qualquer parte destes, ou de
                        quaisquer danos decorrentes de qualquer dos
                        imediatamente acima citados; (d) a Associated Press é
                        uma terceira parte beneficiária deste Acordo de
                        Utilização, e pode exercitar todos os direitos e
                        recursos ora disponíveis; e (e) a Associated Press se
                        reserva o direito de auditoria sobre possíveis usos
                        comerciais não autorizados de materiais da Associated
                        Press ou de parcelas deles, em qualquer momento.
                    </p>

                    <p>
                        Ao usar o Site, você aceita os termos deste Acordo de
                        Utilização. Nós esperamos que você desfrute do Site, e
                        receberemos de bom grado sugestões para melhorias.
                        Obrigado por tornar este Site parte de suas descobertas
                        on-line!
                    </p>

                    <p>Última Atualização: 27 de agosto de 2020.</p>
                </div>
            </Container>
        );
    } else {
        return (
            <Container>
                <div class="cuerpo">
                    <h2>Advertencia legal a los usuarios</h2>

                    <p>
                        Bienvenido a discoverykidsplus.com, uno de los sitios
                        web informativos, educativos y orientados al
                        entretenimiento, ofrecidos por Discovery Communications,
                        LLC, así como por sus subsidiarios y afiliados
                        ("Discovery"). Por favor lea este documento de
                        “Advertencia Legal a los Usuarios”. Al utilizar este
                        sitio Web, usted acepta los términos del mismo.
                        <br />
                        <br />
                        Esta “Advertencia Legal a los Usuarios” aplica para
                        todos los sitios Web en los que esté publicada. A estos
                        sitios web nos referiremos en su conjunto en esta
                        “Advertencia Legal a los Usuarios” como los "Sitios
                        Discovery". Otros términos y condiciones pueden
                        aplicarse a algunos de los servicios ofrecidos en los
                        Sitios Discovery. Tales términos y condiciones pueden
                        encontrarse en el lugar en el que se ofrecen los
                        correspondientes servicios. Por ejemplo, las políticas
                        que rigen las compras a través de DiscoveryStore.com
                        pueden encontrarse al final de cada página web de
                        DiscoveryStore.com.
                        <br />
                        <br />
                        La página web es un medio en constante evolución;
                        Discovery se reserva el derecho de modificar esta
                        “Advertencia Legal a los Usuarios” de manera periódica.
                        Si continúa utilizando cualquier Sitio Discovery después
                        de que dichos cambios se hayan publicado, se entenderá
                        que acepta el nuevo documento de “Advertencia Legal a
                        los Usuarios”, según lo modificado. Discovery se reserva
                        el derecho de restringir el acceso, suspender o
                        interrumpir en cualquier momento los Sitios Discovery,
                        así como una parte de los mismos. Discovery respeta la
                        privacidad de sus usuarios. Por favor, dedique unos
                        minutos a leer con atención nuestra Política de
                        Privacidad.
                        <br />
                        <br />
                        Si usted no está de acuerdo con cualquiera de los
                        contenidos publicados en los Sitios Discovery, le
                        recomendamos que lo notifique comunicando sus
                        discrepancias en un foro del sitio apropiado para ello,
                        en caso de que exista uno. También le invitamos a que
                        nos comunique cualquier material que considere erróneo
                        poniéndose en contacto con nuestros representantes en el
                        siguiente número de teléfono 1-800-889-9950 ó
                        diligenciando el formulario que encontrará en
                        customercare.discovery.com.
                        <br />
                        <br />
                        El material que aparece en los Sitios Discovery está
                        destinado exclusivamente a fines informativos y de
                        entretenimiento. A pesar de nuestros esfuerzos por
                        proporcionar una información útil y precisa,
                        ocasionalmente pueden presentarse algunos errores. Antes
                        de que usted actúe basándose en la información contenida
                        en los Sitios Discovery, usted debe confirmar todos
                        aquellos datos que sean relevantes para su decisión.
                        Discovery y sus proveedores de información no se
                        responsabilizan de la fiabilidad, exactitud, actualidad,
                        utilidad e integridad de la información contenida en los
                        Sitios Discovery. Discovery no se hace responsable y no
                        puede garantizar, la ejecución, los bienes y los
                        servicios proporcionados por nuestros anunciantes o
                        terceros que estén enlazados con este sitio. Un enlace a
                        otra página web no implica la aprobación de este sitio
                        (ni de ningún producto, servicio u otro material
                        ofrecido en este sitio) por parte de Discovery o sus
                        licenciantes.
                    </p>

                    <h2>
                        Notificación y procedimiento para realizar reclamaciones
                        por infracción de derechos de autor
                    </h2>
                    <p>
                        De acuerdo con lo dispuesto en la Sección 512(c) (2) del
                        Título 17 del Código de los Estados Unidos, las
                        reclamaciones por infracción de derechos de propiedad
                        intelectual deberán enviarse al agente designado por el
                        proveedor del servicio.
                        <br />
                        <br />
                        Proveedor de servicios: AT&amp;T
                        <br />
                        <br />
                        Nombre del agente designado para recibir las
                        notificaciones de las reclamaciones: Aaron Holbert
                        <br />
                        <br />
                        Dirección completa del agente al que deben enviarse las
                        notificaciones: Aaron Holbert, Legal Affairs, Discovery
                        Communications, LLC., One Discovery Place, Silver
                        Spring, MD 20910.
                        <br />
                        <br />
                        Número de teléfono del agente: 240.662.0000
                        <br />
                        <br />
                        Número de fax del agente: 240.662.1903
                        <br />
                        <br />
                        Dirección de correo electrónico del agente:
                        DMCA@discovery.com
                        <br />
                        <br />
                        Para ser válida, la notificación deberá realizarse por
                        escrito y contener la siguiente información:
                    </p>
                    <ol>
                        <li>
                            Firma física o electrónica de una persona autorizada
                            para actuar en nombre del titular de un derecho
                            exclusivo sobre el cual se alega la infracción.
                        </li>
                        <li>
                            Identificación de la obra registrada cuyos derechos
                            han sido presuntamente infringidos o, si varias
                            obras registradas en un solo sitio están incluidas
                            en una misma notificación, una lista de tales obras
                            en ese sitio.
                        </li>
                        <li>
                            Identificación del material que supuestamente viola
                            esos derechos de propiedad intelectual y que debe
                            eliminarse o al que debe impedirse el acceso; e
                            información razonablemente suficiente que permita al
                            proveedor del servicio encontrar el material
                            pertinente.
                        </li>
                        <li>
                            Información razonablemente suficiente que permita al
                            proveedor del servicio contactar al denunciante, tal
                            como una dirección, número telefónico, y, en el caso
                            de que esté disponible, una dirección de correo
                            electrónico en la cual el denunciante pueda ser
                            contactado.
                        </li>
                        <li>
                            Una declaración de que el denunciante tiene el
                            convencimiento de buena fe de que el uso del
                            material en la manera en que se está denunciando no
                            está autorizado por el titular de los derechos, su
                            representante o por la ley.
                        </li>
                        <li>
                            Una declaración de que la información es correcta y,
                            bajo pena de perjurio, de que el denunciante está
                            autorizado para actuar en representación del titular
                            de un derecho exclusivo que ha sido presuntamente
                            infringido.
                        </li>
                    </ol>
                    <p>
                        Nos reservamos el derecho de ponernos en contacto con
                        nuestros usuarios mediante un comunicado general
                        publicado en cualquiera de nuestras páginas web, un
                        correo electrónico a la dirección electrónica del
                        usuario que figure en nuestra base de datos, o una
                        notificación escrita enviada por correo certificado a la
                        dirección del usuario que figure en nuestra base de
                        datos. Si recibe la citada notificación, usted tiene el
                        derecho de responder con una contra notificación por
                        escrito dirigida al agente designado, que contenga la
                        información que se cita a continuación. Para ser válida,
                        la contra notificación deberá ser realizada por escrito
                        y contener la siguiente información:
                    </p>

                    <ol>
                        <li>Su firma física o electrónica;</li>
                        <li>
                            Identificación del material que ha sido eliminado o
                            al que se ha impedido el acceso y la ubicación en la
                            que ese material se encontraba antes de su
                            eliminación o de que se impidiera el acceso a él.
                        </li>
                        <li>
                            Una declaración suya bajo pena de perjurio de que
                            usted cree de buena fe que el material ha sido
                            eliminado o deshabilitado como consecuencia de un
                            error o una identificación errónea del material que
                            ha sido eliminado o al que se ha impedido el acceso.
                        </li>
                        <li>
                            Su nombre, dirección y número de teléfono, así como
                            una declaración en la que usted consiente a la
                            jurisdicción de la Corte del Distrito Federal
                            (Federal District Court) correspondiente al distrito
                            judicial en el que se encuentra ubicado su
                            domicilio, o, en caso de que su domicilio se
                            encuentre fuera de los Estados Unidos de América,
                            del distrito judicial en donde podamos encontrarnos,
                            que aceptará la notificación del proceso del
                            individuo que proporcionó la supuesta notificación
                            por infracción o de un agente del mismo.
                        </li>
                    </ol>

                    <h2>Videos generados por el usuario</h2>

                    <p>
                        Al enviar videos grabados por usted a los Sitios
                        Discovery, usted acepta los siguientes términos y
                        condiciones: Considerando la importante contraprestación
                        acordada, cuyo recibo y suficiencia es por la presente
                        reconocida, usted otorga a Discovery Communications,
                        LLC., a sus compañías matrices, empleados, productores,
                        programadores y distribuidores de contenidos, así como a
                        sus respectivos matrices, asociados, afiliados,
                        subsidiarios, autorizados, sucesores y a los cesionarios
                        de todos los mencionados anteriormente (a los que en
                        adelante nos referiremos como los "asociados de
                        Discovery") una licencia no exclusiva, perpetua, exenta
                        de regalías y completamente abonada, para utilizar y
                        distribuir el video que usted ha enviado, así como su
                        nombre, voz, parecido, apariencia (si existiese alguna)
                        y toda la información de identificación personal que
                        usted proporciona en el video o tenga relación con el
                        mismo (al que en adelante nos referiremos como "Su
                        Video"), y que se detalla más abajo en este documento.
                        Usted admite y acuerda que no tiene derecho a compartir
                        ningún beneficio o utilidad que los asociados de
                        Discovery puedan o no obtener o generar gracias a la
                        utilización de “Su Video”.
                        <br />
                        <br />
                        Derecho de los asociados de Discovery a utilizar su
                        video. Usted otorga a los asociados de Discovery el
                        derecho no exclusivo de editar de cualquier forma, de
                        utilizar y distribuir, así como de licenciar a otras
                        personas la utilización y distribución de “Su Video”, o
                        una parte, reproducciones o versiones del mismo en las
                        páginas web, productos y/o servicios (o en cualquier
                        medio de comunicación, actualmente conocido, o por
                        conocerse, incluyendo, sin ninguna limitación,
                        televisión, video / DVD y otros productos o servicios
                        móviles) de los asociados de Discovery, por un número
                        ilimitado de veces, a perpetuidad, en todo el mundo, con
                        o sin cargos o costos para el usuario final u otras
                        terceras partes. Usted también otorga a los “asociados
                        de Discovery” el derecho de utilizar y distribuir “Su
                        Video”, así como de licenciar a otras personas el
                        derecho de utilizar y distribuir Su Video para
                        promocionar dichas páginas web, productos y/o servicios,
                        hasta el mismo nivel permitido para el uso y
                        distribución de “Su Video”, establecido a continuación.
                        <br />
                        <br />
                        Autorización del uso de “Su Video” para los asociados de
                        Discovery. Usted asegura y garantiza que el video que
                        envía es su trabajo original y que usted ha conseguido
                        todos los derechos, permisos de publicación y
                        autorizaciones necesarias para la utilización y
                        distribución de “Su Video” por los asociados de
                        Discovery, incluyendo, sin ninguna limitación, aquellos
                        relacionados con personas, lugares, música, espectáculos
                        de danza o música, videos, fotografías y/o gráficos de
                        su video (a los que en adelante nos referiremos en su
                        conjunto como los "Elementos".) Además, usted asegura y
                        garantiza que, hasta donde tiene conocimiento, ninguna
                        otra autorización u honorarios tendrán que abonarse por
                        la utilización y distribución por parte de los asociados
                        de Discovery de “Su Video” o de cualquiera de los
                        “Elementos” en él incluidos. Además, usted asegura y
                        garantiza que, hasta donde tiene conocimiento, toda
                        afirmación realizada por usted o por terceros en “Su
                        Video” es cierta, y que ni ellos, ni ningún Elemento de
                        “Su Video”, violan ley o regulación alguna, ni violan ni
                        infringen los derechos de terceras partes.
                        <br />
                        <br />
                        Renuncia al derecho de aprobación. Por la presente usted
                        renuncia a cualquier derecho de inspección y aprobación
                        de “Su Video” cualquiera que sea la forma en la que lo
                        utilicen y/o distribuyan los asociados de Discovery,
                        incluyendo, pero sin limitarse a, toda aprobación de su
                        apariencia y/o uso de su nombre, así como las
                        finalidades para las cuales éstos puedan ser utilizados.
                        <br />
                        <br />
                        Publicación y renuncia; Indemnización. Usted admite y
                        reconoce que los asociados de Discovery confiarán en los
                        términos y condiciones anteriormente mencionados,
                        potencialmente a un costo sustancial para ellos, y usted
                        por la presente renuncia a su derecho de efectuar una
                        reclamación de cualquier naturaleza en relación con el
                        ejercicio de los derechos y permisos otorgados,
                        detallados más adelante en este documento. Usted acepta
                        defender, indemnizar y eximir de toda responsabilidad a
                        los asociados de Discovery de todas las posibles
                        reclamaciones que puedan derivarse del uso y
                        distribución de “Su Video” tal y como se autoriza en
                        este documento.
                    </p>

                    <h2>Chats, foros y blogs</h2>
                    <p>
                        Discovery quiere fomentar un intercambio abierto de
                        información e ideas a través de los Sitios Discovery.
                        Pero no podemos y no revisamos cada entrada de los
                        chats, foros, blogs o cualquier otra área pública de los
                        sitios. Usted puede esperar que estas áreas incluyan la
                        información y opiniones de una variedad de individuos y
                        organizaciones diferentes a Discovery. No aprobamos ni
                        garantizamos la exactitud de dichos mensajes, sin
                        importar si las entradas han sido fijadas por un
                        usuario, una celebridad, invitados expertos o un miembro
                        de nuestro personal. No hay sustituto para un sano
                        escepticismo ni para su buen juicio.
                        <br />
                        <br />
                        La responsabilidad sobre la información publicada en los
                        chats, foros, blogs y las otras áreas públicas de los
                        Sitios Discovery es de cada usuario. Usted es el único
                        responsable del material que publica. Discovery no
                        controla los mensajes, la información o cualquier otro
                        contenido que usted u otros suministren a través de los
                        Sitios Discovery. Usted podrá utilizar los Sitios
                        Discovery únicamente con propósitos legales. Al utilizar
                        los Sitios Discovery, usted accede a no fijar ni
                        transmitir material difamatorio, abusivo, obsceno,
                        amenazante o ilegal, ni tampoco fijar ni transmitir
                        material que intervenga en la capacidad de terceros de
                        hacer uso del Sitio Discovery, ni que viole los derechos
                        de otros. Usted no puede fijar ni transmitir mensajes
                        anónimos o bajo nombre falso, ni permitir la entrada de
                        terceros, bajo su cuenta, en secciones de Discovery que
                        estén protegidas por contraseña. Usted no puede fijar el
                        mismo mensaje en más de cinco áreas públicas de los
                        Sitios Discovery, ni fijar ningún mensaje que, según el
                        criterio de los Sitios Discovery, esté fuera de tema o
                        viole este documento de “Advertencia Legal a los
                        Usuarios”.
                        <br />
                        <br />
                        A pesar de que Discovery no puede revisar todas las
                        entradas de los chats, foros, blogs u otras áreas
                        públicas, nos reservamos el derecho (aunque no asumimos
                        la obligación) de monitorear el contenido de los Sitios
                        Discovery para verificar el cumplimiento de esta
                        “Advertencia Legal a los Usuarios” así como de cualquier
                        otro reglamento específico que pudiera establecer
                        Discovery. Discovery tendrá el derecho a su sola
                        discreción de eliminar, mover o editar cualquier
                        mensaje, así como de abstenerse de publicar cualquier
                        material incluyendo pero sin limitarse a, cualquier
                        envío de videos que consideremos inaceptable o
                        inapropiado, ya sea por razones legales o de otra
                        índole. No obstante este derecho, los usuarios son
                        entera y exclusivamente responsables por el contenido de
                        sus mensajes y sus Videos. Usted reconoce y acepta que
                        ni Discovery ni ninguno de sus afiliados asumirán o
                        tendrán responsabilidad alguna por cualquier acción u
                        omisión de Discovery en relación con alguna conducta
                        dentro de los Sitios Discovery o por comunicaciones o
                        publicaciones en los Sitios Discovery. Discovery
                        igualmente se reserva el derecho de revelar toda
                        información que Discovery considere necesaria para dar
                        cumplimiento a una ley, regulación, o petición del
                        gobierno, o de abstenerse de publicar cualquier material
                        en parte o en su totalidad.
                        <br />
                        <br />
                        Discovery le exige que no utilice los Sitios Discovery
                        para violar derechos de autor, marca registrada u otros
                        derechos de propiedad intelectual. Al someter material
                        (incluyendo pero sin limitarse a fotografías y videos) a
                        los Sitios Discovery, usted establece y garantiza que es
                        dueño de dicho material, que tiene derecho a publicar
                        dicho material, o que lo ofrece con el consentimiento de
                        su dueño, y que ninguna otra persona tiene derecho,
                        reclamo o interés en el material que usted publica.
                        Usted también garantiza que los derechos morales sobre
                        el material publicado han sido respetados. Usted cede
                        todos los derechos patrimoniales del material enviado.
                        Enviar material que es propiedad de terceros, sin el
                        previo consentimiento de su propietario, no solamente
                        constituye una violación de este documento de
                        “Advertencia Legal a los Usuarios”, sino que usted puede
                        también incurrir en responsabilidades legales por
                        infracción de los derechos de autor, propiedad
                        industrial, u otros derechos de propiedad intelectual.
                    </p>

                    <h2>Uso de los materiales</h2>
                    <p>
                        Con la excepción de cualquiera o todos los videos
                        enviados por usted (Uso permitido de Discovery
                        establecido anteriormente), y cualquier material
                        publicado en los Sitios Comunitarios y Sociales de
                        Discovery todo el material que envíe a cualquiera de
                        nuestros chats, blogs u otras zonas públicas, ya sea con
                        texto o imágenes, se convierte automáticamente en
                        propiedad de Discovery y puede ser reproducido,
                        modificado y distribuido como creamos conveniente en
                        cualquier medio para cualquier propósito y a
                        perpetuidad. Más aun, usted entiende que al publicar
                        material en los Sitios Comunitarios y Socales de
                        Discovery, usted concede a Discovery o a cualquiera
                        autorizado por Discovery una licencia exenta de
                        regalías, perpetua, irrevocable, no exclusiva, ilimitada
                        y para todo el mundo para exponer, utilizar, copiar,
                        editar, modificar, transmitir, vender, explotar, crear
                        obras derivadas, distribuir o comunicar públicamente
                        dicho material publicado en los Sitios Comunitarios y
                        sociales de Discovery, en su totalidad o en parte, en
                        cualquier forma y a través de cualquier medio conocido o
                        por conocerse y para cualquier propósito. La mencionada
                        autorización incluye el derecho a explotar cualquier
                        derecho de propiedad que surja sobre el material
                        publicado, incluyendo pero sin limitarse a, derechos de
                        autor, de propiedad industrial y en general de propiedad
                        intelectual bajo cualquier jurisdicción aplicable.
                        Adicionalmente, en conexión con el ejercicio de estos
                        derechos usted autoriza a Discovery o a cualquier
                        autorizado por Discovery para identificarlo a usted como
                        autor de cualquier material publicado mediante su
                        nombre, dirección de correo electrónico, o cualquier
                        otro medio que Discovery considere apropiado. Por favor,
                        tenga en cuenta también el último párrafo de los “Chats,
                        foros y blogs”, sección de arriba. Haga clic aquí para
                        los términos y condiciones que rigen el envío de videos
                        grabados por los usuarios y enviados a los Sitios
                        Discovery.
                        <br />
                        <br />
                        Los materiales disponibles a través de los Sitios
                        Discovery son propiedad de Discovery y de sus
                        licenciantes y están protegidos por derechos de autor,
                        propiedad industrial u otras leyes de propiedad
                        intelectual. Usted es libre de visualizar e imprimir
                        para su uso personal y utilización no comercial, la
                        información que recibe a través de los Sitios Discovery.
                        En ningún caso, puede reproducir de cualquier otra
                        manera estos materiales sin el consentimiento previo y
                        escrito del propietario. Usted no puede distribuir
                        copias de los materiales localizados en los Sitios
                        Discovery en ningún formato (incluyendo e-mail u otros
                        medios electrónicos) sin el consentimiento previo y
                        escrito del propietario. Por supuesto que usted es libre
                        de animar a otras personas a acceder a la información de
                        los Sitios Discovery por su propia cuenta y de
                        explicarles cómo acceder a ella.
                    </p>

                    <h2>Links</h2>
                    <p>
                        Otros links siempre serán bienvenidos a los Sitios
                        Discovery.. Usted es libre de fijar un link de
                        hipertexto a cualquiera de los Sitios Discovery siempre
                        y cuando este link no implique ningún patrocinio ni
                        aprobación de este sitio por parte de los Sitios
                        Discovery o por Discovery. En cualquier caso, siempre
                        deberá revisar el aviso de derechos de autor que aparece
                        en la página en la cual usted desea fijar el link para
                        cerciorarse de que nuestros proveedores (de contenido)
                        no dispongan de sus propias políticas relacionadas con
                        los enlaces directos a su contenido en los Sitios
                        Discovery.
                    </p>

                    <h2>Anuncios y donaciones</h2>
                    <p>
                        Usted acepta no utilizar los Sitios Discovery para
                        anunciar o para incitar a cualquier persona a comprar o
                        vender, productos o servicios; ni para solicitar a
                        ninguna persona realizar donaciones de cualquier tipo,
                        sin nuestra explícita aprobación escrita.
                    </p>

                    <h2>Fines comerciales o ilegales</h2>
                    <p>
                        Ocasionalmente, los usuarios publican sus direcciones de
                        e-mail en nuestros chats, foros, blogs y otras áreas
                        públicas. Usted no deberá recolectar estas direcciones
                        de e-mail para fines comerciales o ilegales, tales como
                        enviar correos electrónicos o mensajes instantáneos no
                        deseados.
                    </p>

                    <h2>No reproduccion</h2>
                    <p>
                        Sin el permiso o consentimiento escrito de Discovery,
                        usted no podrá reproducir o hacer que un sitio
                        considerado una tercera parte, presente o apruebe
                        cualquier contenido en los Sitios Discovery; o incorpore
                        cualquier derecho de propiedad intelectual de los Sitios
                        Discovery, de Discovery o de cualquiera de sus
                        licenciantes en otra página web u otro servicio.
                    </p>

                    <h2>Marcas registradas</h2>

                    <p>
                        No deseamos que nadie se confunda en cuanto a los
                        materiales y servicios proporcionados y prestados por
                        Discovery y aquellos que no lo son. Usted no podrá
                        utilizar ninguna marca registrada o de servicio que
                        aparece en los Sitios Discovery, sin el consentimiento
                        previo y escrito del titular de dicha marca.{' '}
                    </p>

                    <h2>Aviso de garantías y responsabilidad</h2>
                    <p>
                        Trabajamos arduamente para que los Sitios Discovery sean
                        un lugar interesante y entretenido pero no podemos
                        garantizar que los usuarios encuentren en ellos todo a
                        su gusto. Por favor, lea este aviso cuidadosamente antes
                        de utilizar cualquier Sitio Discovery.
                        <br />
                        <br />
                        USTED ACEPTA QUE EL USO DE LOS SITIOS DISCOVERY ES A SU
                        PROPIO RIESGO. DEBIDO AL NÚMERO DE LAS POSIBLES FUENTES
                        DE INFORMACIÓN DISPONIBLES A TRAVÉS DE LOS SITIOS
                        DISCOVERY Y A LOS PELIGROS E INCERTIDUMBRES RELACIONADOS
                        CON LA DISTRIBUCIÓN ELECTRÓNICA, PUEDEN ORIGINARSE
                        RETRASOS, OMISIONES U OTROS PROBLEMAS CON DICHA
                        INFORMACIÓN. SI USTED CONFÍA EN CUALQUIER SITIO
                        DISCOVERY O EN CUALQUIER MATERIAL DISPONIBLE A TRAVÉS DE
                        LOS SITIOS DISCOVERY, LO HACE A SU PROPIO RIESGO. USTED
                        ENTIENDE QUE ES EL ÚNICO RESPONSABLE DE CUALQUIER DAÑO A
                        SU SISTEMA INFORMÁTICO ASÍ COMO DE CUALQUIER PÉRDIDA DE
                        DATOS QUE RESULTE DE CUALQUIER MATERIAL O INFORMACIÓN
                        DESCARGADA O PROPORCIONADA A TRAVÉS DE LOS SITIOS
                        DISCOVERY. LOS SITIOS DISCOVERY LE SON PROPORCIONADOS
                        COMO SON, CON SUS FALLOS, Y APARECEN TAL Y COMO ESTÁN
                        DISPONIBLES. LOS SITIOS DISCOVERY, DE DISCOVERY
                        COMMUNICATIONS, LLC. Y DE SUS AFILIADOS, AGENTES Y
                        LICENCIANTES NO PUEDEN Y NO GARANTIZAN EXACTITUD,
                        INTEGRIDAD, ACTUALIDAD, NO INCUMPLIMIENTO,
                        COMERCIABILIDAD O IDONEIDAD PARA UN PROPÓSITO EN
                        PARTICULAR DE LA INFORMACIÓN DISPONIBLE A TRAVÉS DE LOS
                        SITIOS DISCOVERY, NI GARANTIZAN QUE LOS SITIOS DISCOVERY
                        ESTARÁN LIBRES DE ERRORES O DISPONIBLES EN TODO MOMENTO
                        O QUE LOS SITIOS DISCOVERY ESTARÁN LIBRES DE VIRUS O DE
                        OTROS COMPONENTES DAÑINOS. BAJO NINGUNA CIRCUNSTANCIA,
                        LOS SITIOS DISCOVERY, DE DISCOVERY COMMUNICATIONS, LLC.
                        O DE SUS AFILIADOS, AGENTES O LICENCIADORES SERÁN
                        RESPONSABLES DE CUALQUIER DAÑO A USTED O A CUALQUIER
                        OTRA PERSONA QUE SURJA COMO CONSECUENCIA DE LA
                        UTILIZACIÓN DE LOS SITIOS DISCOVERY, INCLUYENDO Y SIN
                        LÍMITES, LA RESPONSABILIDAD POR DAÑOS EMERGENTES,
                        CONSECUENTES, ESPECIALES, FORTUITOS, INDIRECTOS O
                        CUALQUIER OTRO DAÑO SIMILAR, AÚN CUANDO SEAMOS
                        ADVERTIDOS DE LA POSIBILIDAD DE DICHOS DAÑOS. (DEBIDO A
                        QUE ALGUNOS ESTADOS NO PERMITEN LA EXCLUSIÓN O
                        LIMITACIÓN DE CIERTAS CATEGORÍAS DE DAÑOS, LA LIMITACIÓN
                        ARRIBA INDICADA PUEDE NO SER APLICADA A USTED. EN DICHOS
                        ESTADOS, LA RESPONSABILIDAD DE LOS SITIOS DISCOVERY, DE
                        DISCOVERY COMMUNICATIONS, LLC., Y DE SUS AFILIADOS,
                        AGENTES Y LICENCIADORES ESTÁ LIMITADA AL GRADO MÁS BAJO
                        PERMITIDO POR LA LEY DE CADA ESTADO). USTED ACEPTA QUE
                        LA RESPONSABILIDAD DE LOS SITIOS DISCOVERY, DE DISCOVERY
                        COMMUNICATIONS, LLC Y DE SUS AFILIADOS, AGENTES Y
                        LICENCIANTES, DE EXISTIR ALGUNA, QUE SURJA DE CUALQUIER
                        TIPO DE RECLAMACIÓN LEGAL RELACIONADA DE ALGUNA MANERA
                        CON LOS SITIOS DISCOVERY, NO EXCEDA LA CANTIDAD, DE
                        EXISTIR, QUE HA ABONADO A DISCOVERY COMMUNICATIONS, LLC.
                        POR EL USO DE LOS SITIOS DISCOVERY.
                    </p>

                    <h2>Miscelaneo</h2>
                    <p>
                        El personal de Discovery trabaja arduamente para
                        asegurarse de que la información presentada en los
                        Sitios Discovery resulta actualizada y exacta. Sin
                        embargo, las noticias cambian constantemente y los
                        informes que resultaban exactos en el momento de su
                        publicación pueden convertirse rápidamente en viejas
                        noticias. Aunque podemos publicar informes de
                        seguimiento y continuar facilitando el acceso al informe
                        original, como por ejemplo en un archivo de nuevas
                        historias, no volvemos a cambiar el informe original,
                        para reflejar los nuevos acontecimientos o desarrollos.
                        Si usted busca la información más reciente de un tema en
                        específico, y no la historia de cómo este tema se
                        originó, asegúrese de que no está revisando un documento
                        antiguo.
                        <br />
                        <br />
                        Para obtener acceso a ciertos servicios de los Sitios
                        Discovery, es posible que a usted se le brinde la
                        oportunidad de registrarse en Sitios Discovery. Al igual
                        que en cualquier otro procedimiento de registro, usted
                        seleccionará un nombre de usuario y una contraseña.
                        Usted garantiza que la información que ha facilitado
                        durante el procedimiento de registro es exacta y
                        completa y que no se ha registrado o ha intentado
                        acceder a cualquier Sitio Discovery bajo el nombre de
                        otra persona. Discovery se reserva el derecho de
                        rechazar o de eliminar cualquier nombre o contraseña del
                        usuario que en su juicio considere ofensivo. Usted será
                        el responsable de mantener la confidencialidad de su
                        contraseña y de notificar a Discovery en el caso de
                        descubrir el uso sospechoso o desautorizado de su
                        cuenta. Deberá tener al menos 13 años de edad para
                        registrarse en tudiscovery.com. Por favor, informe a
                        Discovery si existe algún cambio en la información que
                        ha facilitado en el momento de su registro inicial,
                        incluyendo el cambio de dirección o nombre, contactando
                        a nuestros representantes en el número1-800-889-9950 o
                        diligenciando nuestro formulario en
                        customercare.discovery.com. Haga clic aquí para ver
                        nuestra política de privacidad
                        <br />
                        <br />
                        Usted acepta indemnizar, defender y proteger a Discovery
                        Communications, LLC., sus afiliados y sus oficiales,
                        directores, empleados, agentes, licenciadores y
                        abastecedores, de y en contra de cualquier pérdida,
                        daños y costos (incluyendo los honorarios razonables de
                        los abogados) resultantes de cualquier violación de este
                        documento de “Advertencia Legal a los Usuarios” y de
                        cualquier actividad relacionada con su cuenta
                        (incluyendo conducta negligente o ilícita) por usted o
                        cualquier otra persona que haya accedido a cualquier
                        Sitio Discovery utilizando su cuenta. Este documento de
                        “Advertencia Legal a los Usuarios” ha sido realizado y
                        será interpretado conforme a las leyes del estado de
                        Maryland, Estados Unidos de America. Al utilizar los
                        Sitios Discovery, usted se somete a la exclusiva
                        jurisdicción del estado de Maryland y de sus cortes
                        federales, en todas las disputas que se presenten
                        relacionadas o no con este documento de “Advertencia
                        Legal a los Usuarios”.
                        <br />
                        <br />
                        En el caso de que una sección o parte de este documento
                        de “Advertencia Legal a los Usuarios” sea considerada
                        inválida o inaplicable por cualquier razón, dicha
                        invalidez o inaplicabilidad no afectará la aplicación o
                        a la validez de cualquier otra parte de este documento
                        de “Advertencia Legal a los Usuarios”, que seguirá
                        teniendo la misma fuerza y efecto; y será interpretado
                        como si la parte inválida o inaplicable no formara parte
                        del documento de “Advertencia Legal a los Usuarios”.
                    </p>

                    <h2>
                        Uso de las reservas de viaje presentadas en
                        travelchannel.com
                    </h2>
                    <p>
                        Las características de las reservas de viaje presentadas
                        en TravelChannel.com se facilitan únicamente a los
                        clientes para ayudarlos a determinar la disponibilidad
                        de productos relacionados con el viaje y servicios así
                        como para realizar reservas legítimas y transacciones de
                        negocio con abastecedores; y no para otros propósitos.
                        Una vez que haya enviado su petición de búsqueda, usted
                        abandonará TravelChannel.com y los otros Sitios
                        Discovery (fíjese en la dirección de Internet una vez
                        que los resultados de su búsqueda hayan aparecido en la
                        pantalla); esto será así aún cuando la marca de
                        TravelChannel.com aparece en la siguiente página que
                        usted podrá ver después de haber enviado su petición de
                        búsqueda. Como resultado de ello, otros términos y
                        condiciones se aplicarán a su reserva y a la compra de
                        productos relacionados con el viaje u otros servicios
                        que haya seleccionado; y usted deberá buscarlos antes de
                        reservar su viaje. Usted acepta seguir los términos y
                        condiciones de compra establecidos por cualquier
                        proveedor que haya elegido para su transacción,
                        incluyendo, pero sin limitarse a, el pago de todas las
                        cantidades en el plazo acordado y el cumplimiento de
                        todas las reglas y restricciones relacionadas con la
                        disponibilidad de las tarifas, productos o servicios.
                        Usted será completamente responsable de todos los
                        cargos, tasas, impuestos y gravámenes derivados del uso
                        de las reservas de viaje facilitadas a través de
                        TravelChannel.com.
                    </p>

                    <h2>
                        Uso de la información de salud de discoveryhealth.com
                    </h2>
                    <p>
                        La información que aparece en DiscoveryHealth.com se
                        presenta únicamente de manera resumida y es creada para
                        facilitar al usuario un entendimiento general de los
                        asuntos relacionados con el cuidado de la salud. Esta
                        información no debe ser utilizada en reemplazo de una
                        visita, llamada o consulta a un médico u otro
                        especialista de la salud. DiscoveryHealth.com no
                        recomienda tratar los problemas médicos por cuenta
                        propia, ni promueve o recomienda una forma de
                        tratamiento médico o alternativo específico. Las
                        personas que acceden a información a través de
                        DiscoveryHealth.com deben también investigar las fuentes
                        de donde proviene dicha información, incluyendo al
                        médico u otro especialista de la salud. La información
                        obtenida al usar DiscoveryHealth.com no es exhaustiva y
                        no cubre todas las enfermedades, dolencias o condiciones
                        físicas, ni su tratamiento. Si usted tiene alguna
                        pregunta relacionada con el cuidado de la salud, por
                        favor, llame o visite a su médico o a otro especialista
                        de la salud. Usted jamás debe desobedecer un consejo
                        médico, o retrasar su aplicación, por algo que ha leído
                        en DiscoveryHealth.com. Siempre deberá buscar asistencia
                        médica inmediata para cualquier asunto relacionado con
                        la salud y consultar a un médico antes de comenzar
                        cualquier tipo de régimen alimenticio o plan de
                        ejercicios.
                    </p>

                    <h2>Contenido de la agencia associated press</h2>
                    <p>
                        Los Sitios Discovery incluyen cierto contenido propiedad
                        de la agencia Associated Press. Sin limitar la
                        generalidad de las provisiones procedentes de este
                        documento de “Advertencia Legal a los Usuarios”, usted
                        específicamente reconoce y acepta que: (a) Los textos de
                        la agencia Associated Press, fotos, gráficos, audio y/o
                        materiales de video no podrán ser publicados,
                        difundidos, re-escritos para nueva difusión o
                        publicación, o redistribuidos directamente o
                        indirectamente en cualquier medio; (b) ningún material o
                        parte de un material relacionado con Associated Press se
                        puede almacenar en una computadora a excepción de
                        hacerlo para su uso personal y no comercial ; (c) la
                        agencia Associated Press no será responsable de ningún
                        retraso, inexactitud, errores u omisiones de contenido o
                        de la transmisión o entrega de todas o alguna parte de
                        éste; ni de cualquier daño o perjuicio que se presente.
                        (d) la agencia Associated Press es una tercera parte
                        prevista que se beneficia de este documento de
                        “Avertencia Legal a los Usuarios”, pudiendo ejercer los
                        mismos derechos y medidas disponibles para éste; y (e)
                        la Associated Press se reserva el derecho de revisar el
                        uso comercial y desautorizado de sus materiales o de
                        cualquier parte de los mismos, en todo momento.
                        <br />
                        <br />
                        Al utilizar los Sitios Discovery, usted acepta los
                        términos de este documento de “Advertencia Legal a los
                        Usuarios” Esperamos que usted disfrute de los Sitios
                        Discovery y le recordamos que aceptamos sugerencias para
                        realizar cualquier tipo de mejora. Gracias por convertir
                        a los Sitios Discovery en parte de sus descubrimientos
                        online.
                        <br />
                        <br />
                        Última actualización: 14 de febrero de 2009
                    </p>
                </div>
            </Container>
        );
    }
};

const Container = styled.div`
    padding: 100px 5vw 20px 5vw;
    margin: 0;
    background-color: #142254;
    font: normal 20px 'Mont';
    color: #fff;
    display: flex;
    justify-content: center;
    * {
        font-family: 'Mont', 'AvenirNextRoundedStd', 'Arial';
        outline: none !important;
        max-width: 1440px;
    }

    a {
        color: #03b795;
    }
    a:hover {
        color: #9df62e;
    }
    a:visited {
        color: #03b795;
    }
    h1 {
        font: normal 50px 'Mont', Arial, sans-serif;
        font-weight: 700;
        color: #fff;
        margin: 0 0 2vw 0;
    }
    h1 .icon {
        display: inline-block;
        width: 6vw;
        height: 8vw;
        margin-right: 1vw;
        vertical-align: top;
    }
    h2 {
        font: normal 40px 'Mont', Arial, sans-serif;
        color: #fff;
        margin: 5vw 0 5vw 0;
    }
    h3 {
        font: normal 30px 'Mont', Arial, sans-serif;
        color: #fff;
        margin: 4vw 0 2vw 0;
    }
    ol,
    ul {
        padding: 2vw 0 2vw 5vw;
        margin: 0;
    }
    li {
        font-family: 'Mont', Helvetica, Arial, sans-serif;
        font-weight: 100;
        margin-top: 1vw;
    }
    p,
    ol,
    ul {
        font-family: 'Mont', Helvetica, Arial, sans-serif;
        font-weight: 100;
    }

    ${mobileMediaQuery} {
        font: normal 16px 'Mont';
        h1 {
            font-size: 32px;
        }
        h2 {
            font-size: 26px;
        }
        h3 {
            font-size: 22px;
        }
    }
`;

export default DKidsPolicy;
